import { useState, useEffect, useRef, useCallback } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { useNavigate } from 'react-router-dom';
import logoImage from '../../PA.svg';
import './WBTAbout.css';
import anatomyImage from './assets/anatomy.png';

const SEARCH_API_URL = 'https://links.szapfs.org';

// Hardcoded metadata - copy-pasted from TSV file
const METADATA = [
  { disease: "Bipolar Disorder", sex: "MALE", age: 21 },
  { disease: "Lung Cancer", sex: "MALE", age: 67 },
  { disease: "Stomach Cancer", sex: "MALE", age: 62 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 70 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 73 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 49 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 58 },
  { disease: "Schizophrenia", sex: "MALE", age: 49 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 4 },
  { disease: "Stomach Cancer", sex: "MALE", age: 62 },
  { disease: "Sepsis", sex: "FEMALE", age: 60 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Habitual Abortion", sex: "MALE", age: 31 },
  { disease: "Sepsis", sex: "FEMALE", age: 62 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 26 },
  { disease: "Sepsis", sex: "MALE", age: 50 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 9 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 55 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 7 },
  { disease: "Stomach Cancer", sex: "MALE", age: 50 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 5 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 30 },
  { disease: "Stomach Cancer", sex: "MALE", age: 68 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 16 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 6 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Epilepsy", sex: "MALE", age: 40 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 8 },
  { disease: "Epilepsy", sex: "MALE", age: 37 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 3 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 16 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 5 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 61 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 77 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 58 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 65 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 50 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 52 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 67 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 10 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 69 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 70 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 68 },
  { disease: "Stomach Cancer", sex: "MALE", age: 69 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 78 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 3 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 68 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 64 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 49 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 52 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 9 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 38 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 45 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 1 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 4 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 70 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 78 },
  { disease: "Epilepsy", sex: "FEMALE", age: 22 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 78 },
  { disease: "Epilepsy", sex: "MALE", age: 21 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 47 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 30 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 16 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 55 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 26 },
  { disease: "Sepsis", sex: "MALE", age: 72 },
  { disease: "Habitual Abortion", sex: "MALE", age: 27 },
  { disease: "Habitual Abortion", sex: "MALE", age: 35 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 35 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 34 },
  { disease: "Sepsis", sex: "MALE", age: 68 },
  { disease: "Habitual Abortion", sex: "MALE", age: 48 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 53 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 8 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Stomach Cancer", sex: "MALE", age: 23 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 6 },
  { disease: "Stomach Cancer", sex: "MALE", age: 67 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 29 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 28 },
  { disease: "Habitual Abortion", sex: "MALE", age: 32 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 67 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 82 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 43 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 61 },
  { disease: "Longevity", sex: "FEMALE", age: 81 },
  { disease: "Longevity", sex: "MALE", age: 80 },
  { disease: "Sepsis", sex: "FEMALE", age: 87 },
  { disease: "Sepsis", sex: "FEMALE", age: 58 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 31 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 49 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 56 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 58 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 57 },
  { disease: "Longevity", sex: "FEMALE", age: 85 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 73 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 21 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 55 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 28 },
  { disease: "Longevity", sex: "MALE", age: 84 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 70 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 7 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 45 },
  { disease: "Sepsis", sex: "MALE", age: 84 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 6 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 59 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 48 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Sepsis", sex: "MALE", age: 72 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 8 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 52 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 16 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 12 },
  { disease: "Epilepsy", sex: "MALE", age: 22 },
  { disease: "Stomach Cancer", sex: "MALE", age: 49 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 44 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 63 },
  { disease: "Longevity", sex: "FEMALE", age: 86 },
  { disease: "Longevity", sex: "FEMALE", age: 84 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 25 },
  { disease: "Longevity", sex: "FEMALE", age: 81 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 75 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 76 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 7 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 35 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 56 },
  { disease: "Habitual Abortion", sex: "MALE", age: 34 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 32 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 29 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 60 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 49 },
  { disease: "Epilepsy", sex: "MALE", age: 25 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 53 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 57 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 50 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 7 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 32 },
  { disease: "Stomach Cancer", sex: "MALE", age: 60 },
  { disease: "Habitual Abortion", sex: "MALE", age: 35 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 60 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 33 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 38 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 68 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 7 },
  { disease: "Sepsis", sex: "FEMALE", age: 75 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 6 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 53 },
  { disease: "Sepsis", sex: "FEMALE", age: 76 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 4 },
  { disease: "Longevity", sex: "FEMALE", age: 81 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "MALE", age: 50 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 53 },
  { disease: "Dystonia", sex: "MALE", age: 38 },
  { disease: "Dystonia", sex: "MALE", age: 36 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 38 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 65 },
  { disease: "Habitual Abortion", sex: "MALE", age: 27 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 78 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 19 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 50 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 67 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 22 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 65 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 78 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 46 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 58 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 68 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 52 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 66 },
  { disease: "Dystonia", sex: "MALE", age: 25 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 74 },
  { disease: "Longevity", sex: "FEMALE", age: 90 },
  { disease: "Longevity", sex: "FEMALE", age: 81 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 36 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 50 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 47 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 49 },
  { disease: "Dystonia", sex: "MALE", age: 59 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 50 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 84 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 10 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 53 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 56 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 48 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 41 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 56 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 63 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 78 },
  { disease: "Epilepsy", sex: "MALE", age: 44 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "MALE", age: 49 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 5 },
  { disease: "Dystonia", sex: "MALE", age: 47 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 55 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 49 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 33 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 65 },
  { disease: "Dystonia", sex: "FEMALE", age: 44 },
  { disease: "Habitual Abortion", sex: "MALE", age: 41 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 60 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 46 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 40 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 68 },
  { disease: "Dystonia", sex: "FEMALE", age: 32 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 56 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 64 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 57 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 62 },
  { disease: "Epilepsy", sex: "MALE", age: 23 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 38 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 35 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 76 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 74 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 72 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 37 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 43 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 53 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 57 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 47 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 53 },
  { disease: "Stomach Cancer", sex: "MALE", age: 55 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 48 },
  { disease: "Dystonia", sex: "MALE", age: 48 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 64 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 80 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 86 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 69 },
  { disease: "Longevity", sex: "FEMALE", age: 92 },
  { disease: "Dystonia", sex: "FEMALE", age: 56 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 57 },
  { disease: "Dystonia", sex: "FEMALE", age: 53 },
  { disease: "Dystonia", sex: "FEMALE", age: 39 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 75 },
  { disease: "Epilepsy", sex: "FEMALE", age: 17 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 71 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 80 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 67 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 39 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 85 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 67 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 68 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 71 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 46 },
  { disease: "Lung Cancer", sex: "MALE", age: 62 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 68 },
  { disease: "Dystonia", sex: "FEMALE", age: 28 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 66 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 69 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 70 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 43 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 68 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 57 },
  { disease: "Essential Tremor", sex: "MALE", age: 46 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 7 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 81 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 53 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 24 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 59 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 31 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 6 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 75 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 52 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 48 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 21 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Longevity", sex: "MALE", age: 83 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 24 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 19 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 21 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 13 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 52 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 66 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 42 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 73 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 57 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 56 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 32 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 82 },
  { disease: "Stomach Cancer", sex: "MALE", age: 61 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 77 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 55 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 68 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 58 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 20 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 37 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Lung Cancer", sex: "MALE", age: 58 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 69 },
  { disease: "Essential Tremor", sex: "MALE", age: 18 },
  { disease: "Gluten Enteropathy", sex: "MALE", age: 29 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 69 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 71 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 62 },
  { disease: "Habitual Abortion", sex: "MALE", age: 35 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 32 },
  { disease: "Habitual Abortion", sex: "MALE", age: 24 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 22 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 32 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 60 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 45 },
  { disease: "Dystonia", sex: "FEMALE", age: 56 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 72 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 60 },
  { disease: "Dystonia", sex: "MALE", age: 38 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Sepsis", sex: "MALE", age: 79 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 55 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 54 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 70 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 29 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 54 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 43 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 50 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 73 },
  { disease: "Lung Cancer", sex: "FEMALE", age: 68 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 36 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 82 },
  { disease: "Lung Cancer", sex: "MALE", age: 48 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 72 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 73 },
  { disease: "Longevity", sex: "FEMALE", age: 81 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 67 },
  { disease: "Longevity", sex: "MALE", age: 86 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 48 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Longevity", sex: "MALE", age: 85 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 60 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 58 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 46 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 68 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 43 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 53 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 55 },
  { disease: "Dystonia", sex: "FEMALE", age: 49 },
  { disease: "Dystonia", sex: "FEMALE", age: 50 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 47 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 27 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 64 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 85 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 42 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 25 },
  { disease: "Dystonia", sex: "MALE", age: 68 },
  { disease: "Schizophrenia", sex: "MALE", age: 54 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "MALE", age: 33 },
  { disease: "Habitual Abortion", sex: "MALE", age: 22 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 23 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 62 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 49 },
  { disease: "Stomach Cancer", sex: "MALE", age: 80 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 59 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 75 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 50 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 56 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 10 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 61 },
  { disease: "Sepsis", sex: "FEMALE", age: 72 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 58 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 65 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 43 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 63 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 70 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 73 },
  { disease: "Essential Tremor", sex: "MALE", age: 70 },
  { disease: "Dystonia", sex: "MALE", age: 55 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 57 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 59 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 63 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 66 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 35 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 56 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 66 },
  { disease: "Habitual Abortion", sex: "MALE", age: 30 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 39 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 32 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 25 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 25 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 28 },
  { disease: "Lung Cancer", sex: "MALE", age: 60 },
  { disease: "Habitual Abortion", sex: "MALE", age: 30 },
  { disease: "Longevity", sex: "MALE", age: 85 },
  { disease: "Longevity", sex: "MALE", age: 86 },
  { disease: "Longevity", sex: "FEMALE", age: 95 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 29 },
  { disease: "Habitual Abortion", sex: "MALE", age: 39 },
  { disease: "Longevity", sex: "MALE", age: 85 },
  { disease: "Habitual Abortion", sex: "MALE", age: 26 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 22 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 37 },
  { disease: "Habitual Abortion", sex: "MALE", age: 30 },
  { disease: "Longevity", sex: "FEMALE", age: 89 },
  { disease: "Longevity", sex: "FEMALE", age: 88 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 72 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 57 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 54 },
  { disease: "Longevity", sex: "FEMALE", age: 81 },
  { disease: "Longevity", sex: "MALE", age: 86 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 50 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 58 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 77 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 77 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 57 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 65 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 62 },
  { disease: "Longevity", sex: "MALE", age: 84 },
  { disease: "Longevity", sex: "MALE", age: 82 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 27 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 48 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 17 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 33 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 67 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 47 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 74 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 75 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 61 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 71 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Multiple Sclerosis", sex: "MALE", age: 27 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 10 },
  { disease: "Longevity", sex: "MALE", age: 88 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Longevity", sex: "FEMALE", age: 85 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 49 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 38 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 65 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 64 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 92 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Longevity", sex: "MALE", age: 85 },
  { disease: "Longevity", sex: "FEMALE", age: 99 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 16 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 46 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 62 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 63 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 48 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 68 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 8 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 7 },
  { disease: "Multiple Sclerosis", sex: "MALE", age: 25 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 41 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 22 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 55 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 48 },
  { disease: "Longevity", sex: "FEMALE", age: 83 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 43 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 41 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 24 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 47 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 47 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 62 },
  { disease: "Longevity", sex: "FEMALE", age: 80 },
  { disease: "Longevity", sex: "FEMALE", age: 80 },
  { disease: "Longevity", sex: "MALE", age: 90 },
  { disease: "Longevity", sex: "MALE", age: 80 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Longevity", sex: "FEMALE", age: 85 },
  { disease: "Longevity", sex: "FEMALE", age: 80 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 74 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 70 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 54 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 54 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 12 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 70 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 65 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 72 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 14 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 74 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 58 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 82 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 58 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 14 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 3 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 21 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 22 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 20 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 39 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 59 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 55 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 58 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 75 },
  { disease: "Longevity", sex: "FEMALE", age: 83 },
  { disease: "Longevity", sex: "MALE", age: 80 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 53 },
  { disease: "Longevity", sex: "FEMALE", age: 90 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 58 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 50 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 25 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 26 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 57 },
  { disease: "Habitual Abortion", sex: "MALE", age: 31 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Longevity", sex: "FEMALE", age: 84 },
  { disease: "Longevity", sex: "MALE", age: 85 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 77 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 63 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 48 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 76 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 47 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 70 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 55 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 72 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 72 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 67 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 59 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 39 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 33 },
  { disease: "Longevity", sex: "FEMALE", age: 95 },
  { disease: "Longevity", sex: "MALE", age: 82 },
  { disease: "Longevity", sex: "MALE", age: 88 },
  { disease: "Longevity", sex: "MALE", age: 84 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 58 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 62 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 45 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 60 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 76 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 53 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 73 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Longevity", sex: "FEMALE", age: 88 },
  { disease: "Longevity", sex: "FEMALE", age: 85 },
  { disease: "Longevity", sex: "FEMALE", age: 87 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 73 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 56 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 65 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 59 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 37 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 42 },
  { disease: "Longevity", sex: "MALE", age: 81 },
  { disease: "Longevity", sex: "FEMALE", age: 91 },
  { disease: "Longevity", sex: "MALE", age: 81 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 60 },
  { disease: "Longevity", sex: "MALE", age: 80 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 77 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 69 },
  { disease: "Longevity", sex: "FEMALE", age: 86 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 60 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 80 },
  { disease: "Longevity", sex: "MALE", age: 81 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 69 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 58 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 57 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 70 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 57 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 78 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 26 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 48 },
  { disease: "Longevity", sex: "MALE", age: 84 },
  { disease: "Longevity", sex: "MALE", age: 86 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Longevity", sex: "MALE", age: 83 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 73 },
  { disease: "Longevity", sex: "FEMALE", age: 83 },
  { disease: "Longevity", sex: "FEMALE", age: 81 },
  { disease: "Gluten Enteropathy", sex: "MALE", age: 38 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 69 },
  { disease: "Longevity", sex: "FEMALE", age: 89 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 69 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 67 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 70 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 62 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 78 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 64 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 16 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 72 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 28 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 12 },
  { disease: "Longevity", sex: "MALE", age: 81 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 68 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 72 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 75 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 67 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 61 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 78 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 73 },
  { disease: "Schizophrenia", sex: "MALE", age: 38 },
  { disease: "Schizophrenia", sex: "MALE", age: 38 },
  { disease: "Schizophrenia", sex: "MALE", age: 48 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 68 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 57 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 61 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 67 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 6 },
  { disease: "Longevity", sex: "FEMALE", age: 86 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 76 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 71 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 53 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 56 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 65 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 48 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 81 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 72 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 67 },
  { disease: "Habitual Abortion", sex: "MALE", age: 30 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 22 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 25 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 28 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 56 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 59 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 55 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 72 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 30 },
  { disease: "Habitual Abortion", sex: "MALE", age: 37 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 15 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 55 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 60 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 36 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 72 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 24 },
  { disease: "Habitual Abortion", sex: "MALE", age: 26 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 8 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 44 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 57 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 62 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 11 },
  { disease: "Longevity", sex: "FEMALE", age: 81 },
  { disease: "Longevity", sex: "MALE", age: 82 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 78 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 61 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 70 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 47 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 65 },
  { disease: "Longevity", sex: "MALE", age: 83 },
  { disease: "Longevity", sex: "MALE", age: 87 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 45 },
  { disease: "Schizophrenia", sex: "MALE", age: 31 },
  { disease: "Schizophrenia", sex: "MALE", age: 51 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 20 },
  { disease: "Habitual Abortion", sex: "MALE", age: 28 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 7 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 70 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 8 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 52 },
  { disease: "Habitual Abortion", sex: "MALE", age: 38 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 29 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 63 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 46 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 56 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 70 },
  { disease: "Longevity", sex: "MALE", age: 80 },
  { disease: "Longevity", sex: "MALE", age: 86 },
  { disease: "Schizophrenia", sex: "MALE", age: 36 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 74 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 64 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 69 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 66 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 33 },
  { disease: "Habitual Abortion", sex: "MALE", age: 42 },
  { disease: "Habitual Abortion", sex: "MALE", age: 24 },
  { disease: "Longevity", sex: "MALE", age: 84 },
  { disease: "Longevity", sex: "FEMALE", age: 86 },
  { disease: "Longevity", sex: "MALE", age: 84 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 55 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 68 },
  { disease: "Longevity", sex: "MALE", age: 80 },
  { disease: "Longevity", sex: "MALE", age: 83 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 24 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 43 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 70 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 29 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 54 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 69 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 73 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 75 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 69 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 33 },
  { disease: "Habitual Abortion", sex: "MALE", age: 41 },
  { disease: "Longevity", sex: "FEMALE", age: 80 },
  { disease: "Longevity", sex: "FEMALE", age: 83 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 60 },
  { disease: "Longevity", sex: "FEMALE", age: 83 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 68 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 67 },
  { disease: "Longevity", sex: "FEMALE", age: 83 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 30 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 24 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 75 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 36 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 58 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 68 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 54 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 67 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 67 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 71 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 74 },
  { disease: "Longevity", sex: "FEMALE", age: 86 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 62 },
  { disease: "Longevity", sex: "MALE", age: 81 },
  { disease: "Longevity", sex: "FEMALE", age: 88 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 77 },
  { disease: "Habitual Abortion", sex: "MALE", age: 36 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 34 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 38 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 28 },
  { disease: "Habitual Abortion", sex: "MALE", age: 31 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 30 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 6 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 40 },
  { disease: "Longevity", sex: "MALE", age: 87 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 54 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 68 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 35 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 73 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 16 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 36 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 73 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 36 },
  { disease: "Longevity", sex: "MALE", age: 91 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 28 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 38 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 48 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 61 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 26 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 75 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 79 },
  { disease: "Longevity", sex: "MALE", age: 87 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 41 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 67 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 51 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Schizophrenia", sex: "MALE", age: 25 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 48 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 74 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 27 },
  { disease: "Habitual Abortion", sex: "MALE", age: 32 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 28 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 75 },
  { disease: "Habitual Abortion", sex: "MALE", age: 39 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 35 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 29 },
  { disease: "Habitual Abortion", sex: "MALE", age: 29 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 45 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 27 },
  { disease: "Habitual Abortion", sex: "MALE", age: 30 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 24 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 25 },
  { disease: "Habitual Abortion", sex: "MALE", age: 31 },
  { disease: "Longevity", sex: "FEMALE", age: 80 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 87 },
  { disease: "Habitual Abortion", sex: "MALE", age: 26 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 20 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 60 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 72 },
  { disease: "Habitual Abortion", sex: "MALE", age: 48 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 3 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 49 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 4 },
  { disease: "Habitual Abortion", sex: "MALE", age: 32 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 68 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 5 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 58 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 75 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 55 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 43 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 29 },
  { disease: "Habitual Abortion", sex: "MALE", age: 28 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 61 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 69 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Gluten Enteropathy", sex: "MALE", age: 57 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 28 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 53 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 68 },
  { disease: "Multiple Sclerosis", sex: "MALE", age: 25 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 50 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 76 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 62 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 21 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 23 },
  { disease: "Habitual Abortion", sex: "MALE", age: 27 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 67 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 73 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 51 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 67 },
  { disease: "Schizophrenia", sex: "MALE", age: 43 },
  { disease: "Longevity", sex: "FEMALE", age: 87 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 14 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 35 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 49 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 7 },
  { disease: "Longevity", sex: "MALE", age: 90 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 18 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 48 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 45 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 81 },
  { disease: "Multiple Sclerosis", sex: "MALE", age: 18 },
  { disease: "Habitual Abortion", sex: "MALE", age: 28 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 30 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 31 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 62 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 64 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 65 },
  { disease: "Gluten Enteropathy", sex: "MALE", age: 55 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 43 },
  { disease: "Habitual Abortion", sex: "MALE", age: 40 },
  { disease: "Gluten Enteropathy", sex: "MALE", age: 50 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 59 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 50 },
  { disease: "Habitual Abortion", sex: "MALE", age: 40 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 36 },
  { disease: "Habitual Abortion", sex: "MALE", age: 29 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 7 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 26 },
  { disease: "Longevity", sex: "MALE", age: 80 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 27 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 58 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 71 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 30 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 19 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 32 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 64 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 66 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 43 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 78 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 74 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 72 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 66 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 77 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 31 },
  { disease: "Habitual Abortion", sex: "MALE", age: 37 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 6 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 35 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 36 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 28 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 37 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 71 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 75 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 75 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 11 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 44 },
  { disease: "Longevity", sex: "MALE", age: 89 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 53 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 80 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 31 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 9 },
  { disease: "Habitual Abortion", sex: "MALE", age: 36 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 1 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 13 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 45 },
  { disease: "Habitual Abortion", sex: "MALE", age: 46 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 71 },
  { disease: "Multiple Sclerosis", sex: "MALE", age: 25 },
  { disease: "Gluten Enteropathy", sex: "MALE", age: 49 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 68 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 63 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 21 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 30 },
  { disease: "Habitual Abortion", sex: "MALE", age: 32 },
  { disease: "Habitual Abortion", sex: "MALE", age: 37 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 35 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 29 },
  { disease: "Habitual Abortion", sex: "MALE", age: 37 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 40 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 63 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 38 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 62 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 15 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 7 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 60 },
  { disease: "Habitual Abortion", sex: "MALE", age: 27 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 26 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 29 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 35 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 10 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 27 },
  { disease: "Habitual Abortion", sex: "MALE", age: 27 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 3 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 36 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 53 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 4 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 67 },
  { disease: "Longevity", sex: "FEMALE", age: 84 },
  { disease: "Gluten Enteropathy", sex: "MALE", age: 29 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 12 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 59 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 53 },
  { disease: "Gluten Enteropathy", sex: "MALE", age: 25 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 39 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 53 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 38 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 38 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 64 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 30 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 40 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 34 },
  { disease: "Longevity", sex: "MALE", age: 92 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 24 },
  { disease: "Longevity", sex: "FEMALE", age: 95 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 64 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 49 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 81 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 51 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 27 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 69 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 3 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 38 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 63 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 16 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 23 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 62 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 7 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 60 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 4 },
  { disease: "Gluten Enteropathy", sex: "MALE", age: 47 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 8 },
  { disease: "Longevity", sex: "FEMALE", age: 80 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 53 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 26 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 41 },
  { disease: "Schizophrenia", sex: "MALE", age: 44 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 4 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 61 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 78 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 65 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 48 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 1 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 72 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 28 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 30 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Longevity", sex: "FEMALE", age: 91 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 5 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 8 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 16 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 50 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 70 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 50 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 21 },
  { disease: "Habitual Abortion", sex: "MALE", age: 31 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 28 },
  { disease: "Habitual Abortion", sex: "MALE", age: 32 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 6 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 9 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 53 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 38 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 7 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 13 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 68 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 76 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 12 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 16 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 61 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Gluten Enteropathy", sex: "MALE", age: 48 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 14 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 59 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 61 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 23 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 14 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 56 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 15 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 43 },
  { disease: "Schizophrenia", sex: "MALE", age: 37 },
  { disease: "Longevity", sex: "MALE", age: 81 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 12 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 4 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 10 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 51 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 10 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 58 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 52 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 33 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 58 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 36 },
  { disease: "Schizophrenia", sex: "MALE", age: 67 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 12 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 23 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 15 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 28 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Habitual Abortion", sex: "MALE", age: 29 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 15 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 6 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 15 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 16 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 6 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 9 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 69 },
  { disease: "Multiple Sclerosis", sex: "MALE", age: 45 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 15 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 51 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 62 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 38 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 40 },
  { disease: "Schizophrenia", sex: "MALE", age: 42 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 28 },
  { disease: "Habitual Abortion", sex: "MALE", age: 28 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 7 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 34 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 12 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 14 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 15 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 43 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 28 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 18 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 13 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 14 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 7 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 14 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 11 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 40 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 12 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 14 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 16 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 16 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 2 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 5 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 16 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 7 },
  { disease: "Longevity", sex: "MALE", age: 82 },
  { disease: "Longevity", sex: "FEMALE", age: 86 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 35 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 67 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 56 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 65 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 7 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 6 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 31 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 51 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 10 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 5 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 30 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 12 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 5 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 8 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 16 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 14 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 2 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 34 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 7 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 5 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 5 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 33 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 12 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 14 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 46 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 15 },
  { disease: "Longevity", sex: "FEMALE", age: 87 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 2 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 10 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 34 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 12 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 5 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 16 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 11 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 30 },
  { disease: "Habitual Abortion", sex: "MALE", age: 34 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Longevity", sex: "FEMALE", age: 91 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 14 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 68 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 68 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 78 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 37 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 13 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 16 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 8 },
  { disease: "Longevity", sex: "MALE", age: 86 },
  { disease: "Longevity", sex: "MALE", age: 84 },
  { disease: "Longevity", sex: "FEMALE", age: 84 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 34 },
  { disease: "Longevity", sex: "MALE", age: 87 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 33 },
  { disease: "Habitual Abortion", sex: "MALE", age: 28 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Longevity", sex: "FEMALE", age: 80 },
  { disease: "Longevity", sex: "MALE", age: 82 },
  { disease: "Longevity", sex: "MALE", age: 80 },
  { disease: "Longevity", sex: "FEMALE", age: 89 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 4 },
  { disease: "Habitual Abortion", sex: "MALE", age: 33 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 33 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 37 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 14 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 30 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 12 },
  { disease: "Habitual Abortion", sex: "MALE", age: 28 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 21 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 15 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 15 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 14 },
  { disease: "Longevity", sex: "MALE", age: 84 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 4 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 39 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 63 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 50 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 67 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 67 },
  { disease: "Longevity", sex: "MALE", age: 82 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 12 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 55 },
  { disease: "Longevity", sex: "MALE", age: 84 },
  { disease: "Longevity", sex: "FEMALE", age: 86 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 34 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 34 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 15 },
  { disease: "Longevity", sex: "MALE", age: 85 },
  { disease: "Longevity", sex: "FEMALE", age: 92 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 52 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 7 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 6 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 11 },
  { disease: "Schizophrenia", sex: "FEMALE", age: 58 },
  { disease: "Longevity", sex: "FEMALE", age: 92 },
  { disease: "Longevity", sex: "FEMALE", age: 81 },
  { disease: "Longevity", sex: "FEMALE", age: 85 },
  { disease: "Longevity", sex: "FEMALE", age: 80 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 35 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 64 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 15 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 4 },
  { disease: "Schizophrenia", sex: "MALE", age: 50 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 66 },
  { disease: "Longevity", sex: "FEMALE", age: 85 },
  { disease: "Longevity", sex: "MALE", age: 93 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 28 },
  { disease: "Habitual Abortion", sex: "MALE", age: 29 },
  { disease: "Habitual Abortion", sex: "MALE", age: 33 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 30 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 14 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 68 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 64 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 35 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 11 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 44 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 40 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 7 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 68 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 39 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 71 },
  { disease: "Longevity", sex: "FEMALE", age: 82 },
  { disease: "Habitual Abortion", sex: "MALE", age: 35 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 29 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 36 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 58 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 70 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 22 },
  { disease: "Lung Cancer", sex: "MALE", age: 58 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 51 },
  { disease: "Lung Cancer", sex: "MALE", age: 77 },
  { disease: "Lung Cancer", sex: "MALE", age: 51 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 54 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 53 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 70 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 63 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 66 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 71 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 60 },
  { disease: "Lung Cancer", sex: "MALE", age: 65 },
  { disease: "Lung Cancer", sex: "MALE", age: 73 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 45 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 45 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 33 },
  { disease: "Lung Cancer", sex: "MALE", age: 73 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 64 },
  { disease: "Dystonia", sex: "MALE", age: 25 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 32 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 55 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 47 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 40 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 44 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 67 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 67 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 38 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 58 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 48 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 82 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 46 },
  { disease: "Dystonia", sex: "FEMALE", age: 75 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 75 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 35 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 25 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Bronchopulmonary Dysplasia", sex: "FEMALE", age: 0 },
  { disease: "Bronchopulmonary Dysplasia", sex: "FEMALE", age: 0 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Dystonia", sex: "FEMALE", age: 45 },
  { disease: "Dystonia", sex: "FEMALE", age: 47 },
  { disease: "Dystonia", sex: "FEMALE", age: 48 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 65 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 57 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 72 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 56 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 32 },
  { disease: "Dystonia", sex: "MALE", age: 53 },
  { disease: "Dystonia", sex: "MALE", age: 70 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 30 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 34 },
  { disease: "Dystonia", sex: "FEMALE", age: 55 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 58 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 78 },
  { disease: "Dystonia", sex: "FEMALE", age: 40 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 47 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 64 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 78 },
  { disease: "Dystonia", sex: "FEMALE", age: 36 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 83 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "MALE", age: 61 },
  { disease: "Lung Cancer", sex: "MALE", age: 59 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 67 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 82 },
  { disease: "Lung Cancer", sex: "MALE", age: 64 },
  { disease: "Lung Cancer", sex: "MALE", age: 68 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 46 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 75 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 90 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 62 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 73 },
  { disease: "Essential Tremor", sex: "MALE", age: 61 },
  { disease: "Lung Cancer", sex: "MALE", age: 60 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 49 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 71 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 39 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 60 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 30 },
  { disease: "Dystonia", sex: "MALE", age: 23 },
  { disease: "Epilepsy", sex: "MALE", age: 34 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 38 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 57 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 49 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 78 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 80 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 60 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 45 },
  { disease: "Essential Tremor", sex: "MALE", age: 68 },
  { disease: "Lung Cancer", sex: "MALE", age: 73 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 65 },
  { disease: "Lung Cancer", sex: "MALE", age: 79 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 55 },
  { disease: "Dystonia", sex: "FEMALE", age: 50 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 53 },
  { disease: "Stomach Cancer", sex: "MALE", age: 65 },
  { disease: "Essential Tremor", sex: "MALE", age: 37 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 26 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 69 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 69 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 75 },
  { disease: "Stomach Cancer", sex: "MALE", age: 73 },
  { disease: "Lung Cancer", sex: "MALE", age: 67 },
  { disease: "Lung Cancer", sex: "MALE", age: 64 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 35 },
  { disease: "Lung Cancer", sex: "MALE", age: 61 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 80 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 73 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 21 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 38 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 50 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 65 },
  { disease: "Essential Tremor", sex: "MALE", age: 67 },
  { disease: "Essential Tremor", sex: "MALE", age: 76 },
  { disease: "Lung Cancer", sex: "MALE", age: 72 },
  { disease: "Lung Cancer", sex: "MALE", age: 83 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 27 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 25 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 65 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Bronchopulmonary Dysplasia", sex: "FEMALE", age: 0 },
  { disease: "Lung Cancer", sex: "MALE", age: 72 },
  { disease: "Lung Cancer", sex: "MALE", age: 74 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 80 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 64 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 46 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 69 },
  { disease: "Lung Cancer", sex: "MALE", age: 87 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 73 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 31 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 62 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 59 },
  { disease: "Stomach Cancer", sex: "MALE", age: 57 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 17 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 76 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 74 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 27 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 18 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 42 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 71 },
  { disease: "Stomach Cancer", sex: "MALE", age: 63 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 58 },
  { disease: "Sepsis", sex: "MALE", age: 84 },
  { disease: "Dystonia", sex: "FEMALE", age: 51 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 25 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 69 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 75 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 22 },
  { disease: "Dystonia", sex: "MALE", age: 37 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 68 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 73 },
  { disease: "Stomach Cancer", sex: "MALE", age: 38 },
  { disease: "Lung Cancer", sex: "MALE", age: 49 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 78 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 71 },
  { disease: "Lung Cancer", sex: "MALE", age: 45 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 53 },
  { disease: "Essential Tremor", sex: "MALE", age: 71 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 73 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 73 },
  { disease: "Dystonia", sex: "MALE", age: 30 },
  { disease: "Dystonia", sex: "MALE", age: 33 },
  { disease: "Lung Cancer", sex: "MALE", age: 85 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 30 },
  { disease: "Essential Tremor", sex: "MALE", age: 70 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 53 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 35 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 70 },
  { disease: "Lung Cancer", sex: "MALE", age: 72 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 80 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 28 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 50 },
  { disease: "Stomach Cancer", sex: "MALE", age: 60 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 65 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 83 },
  { disease: "Lung Cancer", sex: "MALE", age: 68 },
  { disease: "Lung Cancer", sex: "MALE", age: 79 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 52 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 77 },
  { disease: "Lung Cancer", sex: "FEMALE", age: 44 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 20 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 77 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 59 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 68 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 64 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 65 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 17 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 28 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 21 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 34 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 22 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 79 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 69 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Lung Cancer", sex: "MALE", age: 74 },
  { disease: "Epilepsy", sex: "FEMALE", age: 34 },
  { disease: "Stomach Cancer", sex: "MALE", age: 52 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 68 },
  { disease: "Stomach Cancer", sex: "MALE", age: 60 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 62 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 87 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Lung Cancer", sex: "MALE", age: 55 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 25 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 62 },
  { disease: "Lung Cancer", sex: "MALE", age: 70 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "MALE", age: 55 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 72 },
  { disease: "Essential Tremor", sex: "MALE", age: 56 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 34 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Stomach Cancer", sex: "MALE", age: 79 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 76 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 22 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 69 },
  { disease: "Essential Tremor", sex: "MALE", age: 79 },
  { disease: "Essential Tremor", sex: "MALE", age: 78 },
  { disease: "Lung Cancer", sex: "MALE", age: 67 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Essential Tremor", sex: "MALE", age: 66 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 80 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 85 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 79 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 21 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 60 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 54 },
  { disease: "Stomach Cancer", sex: "MALE", age: 76 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 89 },
  { disease: "Lung Cancer", sex: "MALE", age: 71 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 73 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 81 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 81 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 74 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 32 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 61 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Stomach Cancer", sex: "MALE", age: 58 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 57 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 66 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Dystonia", sex: "FEMALE", age: 54 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 35 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 84 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 75 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 89 },
  { disease: "Essential Tremor", sex: "MALE", age: 65 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 42 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 22 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 34 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 63 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 49 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 32 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 67 },
  { disease: "Lung Cancer", sex: "MALE", age: 53 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 37 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 68 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 73 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 87 },
  { disease: "Epilepsy", sex: "FEMALE", age: 23 },
  { disease: "Lung Cancer", sex: "FEMALE", age: 52 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 77 },
  { disease: "Essential Tremor", sex: "MALE", age: 63 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 70 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 38 },
  { disease: "Essential Tremor", sex: "MALE", age: 55 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 81 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 67 },
  { disease: "Sepsis", sex: "MALE", age: 77 },
  { disease: "Sepsis", sex: "MALE", age: 65 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 32 },
  { disease: "Epilepsy", sex: "FEMALE", age: 63 },
  { disease: "Epilepsy", sex: "MALE", age: 40 },
  { disease: "Epilepsy", sex: "MALE", age: 29 },
  { disease: "Epilepsy", sex: "FEMALE", age: 38 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 67 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Sepsis", sex: "MALE", age: 66 },
  { disease: "Sepsis", sex: "FEMALE", age: 99 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 57 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 71 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 32 },
  { disease: "Essential Tremor", sex: "MALE", age: 67 },
  { disease: "Essential Tremor", sex: "MALE", age: 74 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 61 },
  { disease: "Sepsis", sex: "FEMALE", age: 83 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 21 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 21 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 21 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 66 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 27 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 85 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 22 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Epilepsy", sex: "FEMALE", age: 22 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 25 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 66 },
  { disease: "Epilepsy", sex: "FEMALE", age: 22 },
  { disease: "Epilepsy", sex: "FEMALE", age: 20 },
  { disease: "Epilepsy", sex: "FEMALE", age: 29 },
  { disease: "Epilepsy", sex: "MALE", age: 41 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 25 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 60 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 25 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 47 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 28 },
  { disease: "Essential Tremor", sex: "MALE", age: 49 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 65 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 71 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 27 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 57 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 60 },
  { disease: "Epilepsy", sex: "MALE", age: 26 },
  { disease: "Epilepsy", sex: "FEMALE", age: 26 },
  { disease: "Epilepsy", sex: "FEMALE", age: 51 },
  { disease: "Epilepsy", sex: "MALE", age: 48 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 72 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 18 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 65 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 57 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 59 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 56 },
  { disease: "Essential Tremor", sex: "MALE", age: 29 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 19 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 74 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 68 },
  { disease: "Epilepsy", sex: "MALE", age: 31 },
  { disease: "Epilepsy", sex: "MALE", age: 38 },
  { disease: "Epilepsy", sex: "FEMALE", age: 34 },
  { disease: "Epilepsy", sex: "FEMALE", age: 52 },
  { disease: "Epilepsy", sex: "FEMALE", age: 38 },
  { disease: "Essential Tremor", sex: "MALE", age: 18 },
  { disease: "Epilepsy", sex: "MALE", age: 42 },
  { disease: "Epilepsy", sex: "FEMALE", age: 27 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 73 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 60 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 49 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 51 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 80 },
  { disease: "Dystonia", sex: "FEMALE", age: 66 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 32 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 58 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 27 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 32 },
  { disease: "Sepsis", sex: "FEMALE", age: 77 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Epilepsy", sex: "FEMALE", age: 39 },
  { disease: "Epilepsy", sex: "FEMALE", age: 24 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 62 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 72 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 23 },
  { disease: "Essential Tremor", sex: "MALE", age: 24 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 46 },
  { disease: "Lung Cancer", sex: "MALE", age: 68 },
  { disease: "Lung Cancer", sex: "MALE", age: 62 },
  { disease: "Sepsis", sex: "FEMALE", age: 49 },
  { disease: "Sepsis", sex: "MALE", age: 75 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 39 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 68 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 25 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 51 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 33 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 47 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 49 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 70 },
  { disease: "Sepsis", sex: "FEMALE", age: 74 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 48 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 38 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 17 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 25 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 57 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 45 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 38 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 34 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 49 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 71 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 52 },
  { disease: "Lung Cancer", sex: "MALE", age: 62 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 19 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 49 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 56 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 24 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 35 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 41 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 60 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 50 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 49 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 45 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 63 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 58 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 36 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 52 },
  { disease: "Lung Cancer", sex: "MALE", age: 83 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 56 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 38 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 29 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 41 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Epilepsy", sex: "FEMALE", age: 42 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 70 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 22 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 18 },
  { disease: "Stomach Cancer", sex: "MALE", age: 51 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 75 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 77 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 47 },
  { disease: "Epilepsy", sex: "MALE", age: 19 },
  { disease: "ANCA-Associated Vasculitis", sex: "MALE", age: 37 },
  { disease: "Sepsis", sex: "MALE", age: 61 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Stomach Cancer", sex: "MALE", age: 56 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 85 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Lung Cancer", sex: "MALE", age: 55 },
  { disease: "Epilepsy", sex: "MALE", age: 34 },
  { disease: "Epilepsy", sex: "MALE", age: 33 },
  { disease: "Epilepsy", sex: "MALE", age: 52 },
  { disease: "Epilepsy", sex: "MALE", age: 32 },
  { disease: "Epilepsy", sex: "FEMALE", age: 22 },
  { disease: "Epilepsy", sex: "MALE", age: 36 },
  { disease: "Epilepsy", sex: "FEMALE", age: 26 },
  { disease: "Epilepsy", sex: "MALE", age: 20 },
  { disease: "Lung Cancer", sex: "MALE", age: 56 },
  { disease: "Lung Cancer", sex: "MALE", age: 60 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 84 },
  { disease: "Sepsis", sex: "MALE", age: 90 },
  { disease: "Epilepsy", sex: "MALE", age: 39 },
  { disease: "Epilepsy", sex: "FEMALE", age: 34 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 26 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 27 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 42 },
  { disease: "Sepsis", sex: "MALE", age: 59 },
  { disease: "Stomach Cancer", sex: "MALE", age: 61 },
  { disease: "Lung Cancer", sex: "MALE", age: 63 },
  { disease: "Stomach Cancer", sex: "MALE", age: 59 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 82 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 58 },
  { disease: "Sepsis", sex: "FEMALE", age: 61 },
  { disease: "Sepsis", sex: "MALE", age: 73 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 49 },
  { disease: "Lung Cancer", sex: "MALE", age: 57 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 61 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 67 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 73 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 69 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 68 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 54 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 73 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 68 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 49 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 63 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 53 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 60 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 65 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 31 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 59 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 62 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 35 },
  { disease: "Essential Tremor", sex: "MALE", age: 49 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 82 },
  { disease: "Essential Tremor", sex: "MALE", age: 38 },
  { disease: "Lung Cancer", sex: "MALE", age: 60 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 24 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 61 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 55 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 33 },
  { disease: "Sepsis", sex: "MALE", age: 64 },
  { disease: "Sepsis", sex: "FEMALE", age: 43 },
  { disease: "Sepsis", sex: "MALE", age: 40 },
  { disease: "Sepsis", sex: "FEMALE", age: 68 },
  { disease: "Sepsis", sex: "FEMALE", age: 65 },
  { disease: "Sepsis", sex: "FEMALE", age: 79 },
  { disease: "Sepsis", sex: "MALE", age: 62 },
  { disease: "Epilepsy", sex: "FEMALE", age: 20 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 75 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 62 },
  { disease: "Epilepsy", sex: "FEMALE", age: 25 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 75 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 80 },
  { disease: "Stomach Cancer", sex: "MALE", age: 80 },
  { disease: "Stomach Cancer", sex: "MALE", age: 68 },
  { disease: "Dystonia", sex: "FEMALE", age: 68 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 65 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 70 },
  { disease: "Lung Cancer", sex: "MALE", age: 69 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 22 },
  { disease: "Sepsis", sex: "MALE", age: 58 },
  { disease: "Epilepsy", sex: "MALE", age: 39 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 57 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 66 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 78 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 69 },
  { disease: "Epilepsy", sex: "FEMALE", age: 44 },
  { disease: "Epilepsy", sex: "FEMALE", age: 53 },
  { disease: "Epilepsy", sex: "FEMALE", age: 39 },
  { disease: "Epilepsy", sex: "FEMALE", age: 27 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 73 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 18 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 70 },
  { disease: "Lung Cancer", sex: "MALE", age: 66 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 63 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 35 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 28 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 19 },
  { disease: "Sepsis", sex: "FEMALE", age: 75 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 53 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 65 },
  { disease: "Sepsis", sex: "FEMALE", age: 84 },
  { disease: "Epilepsy", sex: "FEMALE", age: 19 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 22 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 84 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 48 },
  { disease: "Essential Tremor", sex: "MALE", age: 61 },
  { disease: "Lung Cancer", sex: "FEMALE", age: 78 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 70 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 89 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 25 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 35 },
  { disease: "Lung Cancer", sex: "MALE", age: 75 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 22 },
  { disease: "Lung Cancer", sex: "MALE", age: 55 },
  { disease: "Stomach Cancer", sex: "MALE", age: 62 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 35 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 79 },
  { disease: "Stomach Cancer", sex: "MALE", age: 62 },
  { disease: "Epilepsy", sex: "MALE", age: 76 },
  { disease: "Epilepsy", sex: "MALE", age: 19 },
  { disease: "Epilepsy", sex: "MALE", age: 25 },
  { disease: "Epilepsy", sex: "FEMALE", age: 23 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 85 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 77 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 27 },
  { disease: "Epilepsy", sex: "FEMALE", age: 19 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 28 },
  { disease: "Dystonia", sex: "MALE", age: 41 },
  { disease: "Epilepsy", sex: "FEMALE", age: 40 },
  { disease: "Epilepsy", sex: "FEMALE", age: 30 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 71 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 59 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 79 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 48 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 57 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 32 },
  { disease: "Epilepsy", sex: "MALE", age: 39 },
  { disease: "Epilepsy", sex: "MALE", age: 37 },
  { disease: "Epilepsy", sex: "MALE", age: 42 },
  { disease: "Epilepsy", sex: "MALE", age: 55 },
  { disease: "Epilepsy", sex: "MALE", age: 32 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 81 },
  { disease: "Essential Tremor", sex: "MALE", age: 37 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 45 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 21 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 39 },
  { disease: "Epilepsy", sex: "MALE", age: 54 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "MALE", age: 51 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 72 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 69 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 25 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 58 },
  { disease: "Epilepsy", sex: "FEMALE", age: 29 },
  { disease: "Epilepsy", sex: "FEMALE", age: 25 },
  { disease: "Epilepsy", sex: "MALE", age: 26 },
  { disease: "Epilepsy", sex: "MALE", age: 22 },
  { disease: "Epilepsy", sex: "FEMALE", age: 28 },
  { disease: "Epilepsy", sex: "FEMALE", age: 28 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 46 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 36 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 46 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 66 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 38 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 70 },
  { disease: "Epilepsy", sex: "FEMALE", age: 23 },
  { disease: "Epilepsy", sex: "FEMALE", age: 40 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 76 },
  { disease: "Sepsis", sex: "FEMALE", age: 66 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 24 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 29 },
  { disease: "Epilepsy", sex: "MALE", age: 22 },
  { disease: "Epilepsy", sex: "MALE", age: 26 },
  { disease: "Epilepsy", sex: "MALE", age: 48 },
  { disease: "Epilepsy", sex: "FEMALE", age: 23 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 46 },
  { disease: "Schizophrenia", sex: "MALE", age: 29 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 39 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 72 },
  { disease: "Sepsis", sex: "FEMALE", age: 83 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 48 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 72 },
  { disease: "Epilepsy", sex: "MALE", age: 42 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 46 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 30 },
  { disease: "Epilepsy", sex: "FEMALE", age: 21 },
  { disease: "Sepsis", sex: "MALE", age: 76 },
  { disease: "Sepsis", sex: "MALE", age: 81 },
  { disease: "Lung Cancer", sex: "MALE", age: 76 },
  { disease: "Stomach Cancer", sex: "MALE", age: 52 },
  { disease: "Lung Cancer", sex: "MALE", age: 77 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 62 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 68 },
  { disease: "Epilepsy", sex: "FEMALE", age: 49 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 46 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 47 },
  { disease: "Epilepsy", sex: "MALE", age: 17 },
  { disease: "Lung Cancer", sex: "MALE", age: 70 },
  { disease: "Epilepsy", sex: "FEMALE", age: 20 },
  { disease: "Lung Cancer", sex: "MALE", age: 41 },
  { disease: "Lung Cancer", sex: "MALE", age: 57 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 29 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 24 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 62 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 30 },
  { disease: "Sepsis", sex: "FEMALE", age: 89 },
  { disease: "Sepsis", sex: "MALE", age: 58 },
  { disease: "Epilepsy", sex: "MALE", age: 33 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 36 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 79 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 51 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 53 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 37 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 37 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 25 },
  { disease: "Stomach Cancer", sex: "MALE", age: 72 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 86 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 37 },
  { disease: "Sepsis", sex: "MALE", age: 69 },
  { disease: "Sepsis", sex: "MALE", age: 68 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 61 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 53 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 78 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 63 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 46 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 47 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 40 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 53 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 57 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 58 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 27 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 60 },
  { disease: "Stomach Cancer", sex: "MALE", age: 78 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 63 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 71 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 62 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 68 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 29 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 48 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 77 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 65 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 69 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 58 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 40 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 25 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 35 },
  { disease: "Epilepsy", sex: "MALE", age: 32 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 35 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 21 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 28 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 49 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 52 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 33 },
  { disease: "Sepsis", sex: "MALE", age: 80 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 75 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 65 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 56 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 36 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 28 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 37 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 55 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 75 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 51 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 69 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 73 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 73 },
  { disease: "Renal Stones", sex: "MALE", age: 46 },
  { disease: "Renal Stones", sex: "MALE", age: 43 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 14 },
  { disease: "Nocturnal Enuresis", sex: "FEMALE", age: 9 },
  { disease: "Nocturnal Enuresis", sex: "MALE", age: 9 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 71 },
  { disease: "Nocturnal Enuresis", sex: "MALE", age: 9 },
  { disease: "Childhood Renal Stones", sex: "FEMALE", age: 0 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 1 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 41 },
  { disease: "Nocturnal Enuresis", sex: "FEMALE", age: 12 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 15 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 15 },
  { disease: "Nocturnal Enuresis", sex: "FEMALE", age: 11 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 17 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 9 },
  { disease: "Nocturnal Enuresis", sex: "MALE", age: 11 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 8 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 8 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 42 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 38 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "FEMALE", age: 79 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 54 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 1 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 75 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 23 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 42 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 61 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 9 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 1 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 3 },
  { disease: "Asthma", sex: "MALE", age: 5 },
  { disease: "Brucellosis", sex: "MALE", age: 24 },
  { disease: "Chronic Hepatitis B", sex: "FEMALE", age: 52 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 13 },
  { disease: "Asthma", sex: "FEMALE", age: 6 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 7 },
  { disease: "Familial Mediterranean Fever", sex: "MALE", age: 0 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 4 },
  { disease: "Familial Mediterranean Fever", sex: "MALE", age: 0 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 5 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 27 },
  { disease: "Asthma", sex: "MALE", age: 6 },
  { disease: "Familial Mediterranean Fever", sex: "MALE", age: 0 },
  { disease: "Asthma", sex: "MALE", age: 5 },
  { disease: "Leukemia", sex: "FEMALE", age: 55 },
  { disease: "Liver Cancer", sex: "MALE", age: 71 },
  { disease: "Glaucoma", sex: "MALE", age: 61 },
  { disease: "Glaucoma", sex: "MALE", age: 37 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 59 },
  { disease: "Glaucoma", sex: "MALE", age: 61 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Asthma", sex: "MALE", age: 4 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 5 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "FEMALE", age: 57 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 3 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 1 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 9 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 14 },
  { disease: "Liver Cancer", sex: "MALE", age: 59 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 46 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "FEMALE", age: 66 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 83 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Nocturnal Enuresis", sex: "FEMALE", age: 7 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Asthma", sex: "MALE", age: 10 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Asthma", sex: "MALE", age: 3 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 15 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 21 },
  { disease: "Familial Mediterranean Fever", sex: "MALE", age: 15 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 13 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 28 },
  { disease: "Liver Cancer", sex: "MALE", age: 46 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 13 },
  { disease: "Renal Stones", sex: "MALE", age: 64 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 97 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 45 },
  { disease: "Diabetic Complications", sex: "MALE", age: 77 },
  { disease: "Chronic Hepatitis B", sex: "FEMALE", age: 53 },
  { disease: "Glaucoma", sex: "MALE", age: 27 },
  { disease: "Diabetic Complications", sex: "MALE", age: 63 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 15 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 39 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 8 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 21 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 13 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 8 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 2 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 9 },
  { disease: "Asthma", sex: "MALE", age: 6 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 10 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 20 },
  { disease: "Liver Cancer", sex: "MALE", age: 71 },
  { disease: "Liver Cancer", sex: "MALE", age: 63 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 60 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "FEMALE", age: 67 },
  { disease: "Diabetic Complications", sex: "MALE", age: 51 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 66 },
  { disease: "Leukemia", sex: "MALE", age: 49 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 13 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 58 },
  { disease: "Familial Mediterranean Fever", sex: "MALE", age: 44 },
  { disease: "Familial Mediterranean Fever", sex: "FEMALE", age: 38 },
  { disease: "Diabetic Complications", sex: "MALE", age: 58 },
  { disease: "Asthma", sex: "MALE", age: 7 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 1 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 84 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 1 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atypical Parkinsonism", sex: "FEMALE", age: 61 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 15 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 10 },
  { disease: "Asthma", sex: "MALE", age: 7 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 17 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 1 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Asthma", sex: "FEMALE", age: 15 },
  { disease: "Diabetic Complications", sex: "MALE", age: 68 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 22 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 7 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 11 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 40 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 1 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 4 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 1 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 1 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 33 },
  { disease: "Familial Mediterranean Fever", sex: "FEMALE", age: 4 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 11 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 61 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 50 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 11 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 1 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 36 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 42 },
  { disease: "ANCA-Associated Vasculitis", sex: "FEMALE", age: 58 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 58 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 76 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 18 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 50 },
  { disease: "Diabetic Complications", sex: "MALE", age: 62 },
  { disease: "ANCA-Associated Vasculitis", sex: "MALE", age: 36 },
  { disease: "Chronic Hepatitis B", sex: "FEMALE", age: 32 },
  { disease: "Familial Mediterranean Fever", sex: "MALE", age: 6 },
  { disease: "ANCA-Associated Vasculitis", sex: "FEMALE", age: 32 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 7 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 10 },
  { disease: "Familial Mediterranean Fever", sex: "MALE", age: 27 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 11 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 17 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 13 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 15 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 49 },
  { disease: "Familial Mediterranean Fever", sex: "MALE", age: 11 },
  { disease: "Febrile Convulsion", sex: "MALE", age: 5 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 2 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "FEMALE", age: 14 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 1 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 11 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 4 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 12 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "FEMALE", age: 17 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 1 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 1 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 60 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 14 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "FEMALE", age: 41 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 8 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 1 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 13 },
  { disease: "Febrile Convulsion", sex: "FEMALE", age: 1 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 13 },
  { disease: "Febrile Convulsion", sex: "MALE", age: 1 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 5 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 15 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 75 },
  { disease: "ANCA-Associated Vasculitis", sex: "MALE", age: 71 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 16 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 58 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 62 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 48 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 5 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 7 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 1 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 7 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 52 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 17 },
  { disease: "Febrile Convulsion", sex: "MALE", age: 2 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 8 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 6 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 1 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 16 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 84 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 14 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 18 },
  { disease: "Sudden Hearing Loss", sex: "FEMALE", age: 3 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 17 },
  { disease: "Atypical Parkinsonism", sex: "FEMALE", age: 62 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 16 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 25 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 58 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 35 },
  { disease: "Familial Mediterranean Fever", sex: "FEMALE", age: 28 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 64 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 56 },
  { disease: "Febrile Convulsion", sex: "MALE", age: 2 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 52 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 63 },
  { disease: "Atypical Parkinsonism", sex: "FEMALE", age: 51 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 26 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 14 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 77 },
  { disease: "Chronic Hepatitis B", sex: "FEMALE", age: 48 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 31 },
  { disease: "ANCA-Associated Vasculitis", sex: "MALE", age: 51 },
  { disease: "Febrile Convulsion", sex: "FEMALE", age: 1 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 13 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 1 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Febrile Convulsion", sex: "MALE", age: 3 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 13 },
  { disease: "Familial Mediterranean Fever", sex: "FEMALE", age: 53 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 11 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 12 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 14 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 16 },
  { disease: "Frontotemporal Dementia", sex: "MALE", age: 74 },
  { disease: "ANCA-Associated Vasculitis", sex: "FEMALE", age: 46 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 71 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 45 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 76 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 15 },
  { disease: "Atypical Parkinsonism", sex: "FEMALE", age: 65 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 32 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 66 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 8 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 2 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "FEMALE", age: 11 },
  { disease: "Frontotemporal Dementia", sex: "MALE", age: 73 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 18 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 69 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 6 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 21 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 14 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 12 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 5 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 2 },
  { disease: "Brucellosis", sex: "MALE", age: 57 },
  { disease: "Frontotemporal Dementia", sex: "MALE", age: 55 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 26 },
  { disease: "Chronic Hepatitis B", sex: "FEMALE", age: 68 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 21 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 23 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 33 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 11 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 1 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 17 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 5 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 3 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 12 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 11 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 1 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 17 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 15 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 47 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 75 },
  { disease: "Familial Mediterranean Fever", sex: "FEMALE", age: 38 },
  { disease: "Major Depressive Disorder", sex: "MALE", age: 17 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 18 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 37 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 10 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 12 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 17 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 36 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 60 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 57 },
  { disease: "Acute Pancreatitis", sex: "FEMALE", age: 57 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 11 },
  { disease: "Acute Pancreatitis", sex: "FEMALE", age: 51 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 56 },
  { disease: "Carbon Monoxide Poisoning", sex: "MALE", age: 57 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 65 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 75 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 16 },
  { disease: "ANCA-Associated Vasculitis", sex: "FEMALE", age: 68 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 3 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 17 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 11 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 13 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 16 },
  { disease: "ANCA-Associated Vasculitis", sex: "FEMALE", age: 26 },
  { disease: "Nocturnal Enuresis", sex: "FEMALE", age: 10 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 56 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 52 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 2 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 7 },
  { disease: "Acute Pancreatitis", sex: "MALE", age: 49 },
  { disease: "Periodontitis", sex: "FEMALE", age: 38 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 45 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 17 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 6 },
  { disease: "Down Syndrome", sex: "MALE", age: 0 },
  { disease: "Drug Intoxication", sex: "MALE", age: 21 },
  { disease: "Periodontitis", sex: "FEMALE", age: 24 },
  { disease: "Frontotemporal Dementia", sex: "MALE", age: 87 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 16 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 17 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 12 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "FEMALE", age: 4 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 69 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 27 },
  { disease: "Down Syndrome", sex: "MALE", age: 0 },
  { disease: "Down Syndrome", sex: "MALE", age: 0 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 27 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 48 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "MALE", age: 6 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 5 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 4 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 23 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "FEMALE", age: 9 },
  { disease: "Atypical Parkinsonism", sex: "FEMALE", age: 75 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 19 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 42 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 20 },
  { disease: "Acute Pancreatitis", sex: "FEMALE", age: 27 },
  { disease: "Drug Intoxication", sex: "MALE", age: 25 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 75 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 55 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 40 },
  { disease: "Brucellosis", sex: "MALE", age: 73 },
  { disease: "Diabetic Complications", sex: "FEMALE", age: 71 },
  { disease: "Diabetic Complications", sex: "MALE", age: 68 },
  { disease: "Frontotemporal Dementia", sex: "MALE", age: 72 },
  { disease: "Frontotemporal Dementia", sex: "MALE", age: 73 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 45 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 4 },
  { disease: "Acute Pancreatitis", sex: "MALE", age: 74 },
  { disease: "Brucellosis", sex: "MALE", age: 56 },
  { disease: "Brucellosis", sex: "MALE", age: 23 },
  { disease: "Familial Mediterranean Fever", sex: "MALE", age: 5 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 58 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 44 },
  { disease: "Brucellosis", sex: "FEMALE", age: 67 },
  { disease: "Blepharospasm", sex: "MALE", age: 49 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "MALE", age: 17 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 17 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 19 },
  { disease: "Blepharospasm", sex: "MALE", age: 59 },
  { disease: "Acute Pancreatitis", sex: "MALE", age: 36 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 9 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "FEMALE", age: 7 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 17 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 9 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 7 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 57 },
  { disease: "Chronic Hepatitis B", sex: "FEMALE", age: 67 },
  { disease: "Drug Intoxication", sex: "MALE", age: 29 },
  { disease: "Periodontitis", sex: "FEMALE", age: 36 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 59 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 23 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 20 },
  { disease: "Chronic Hepatitis B", sex: "FEMALE", age: 24 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "FEMALE", age: 4 },
  { disease: "Childhood Renal Stones", sex: "FEMALE", age: 0 },
  { disease: "Drug Intoxication", sex: "MALE", age: 31 },
  { disease: "Acute Pancreatitis", sex: "MALE", age: 49 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 11 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 49 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 69 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 32 },
  { disease: "Acute Pancreatitis", sex: "MALE", age: 67 },
  { disease: "Brucellosis", sex: "MALE", age: 59 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 72 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 34 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 10 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 11 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 7 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 7 },
  { disease: "Acute Pancreatitis", sex: "FEMALE", age: 60 },
  { disease: "Glaucoma", sex: "MALE", age: 77 },
  { disease: "Glaucoma", sex: "MALE", age: 28 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 37 },
  { disease: "Blepharospasm", sex: "MALE", age: 49 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 50 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 9 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 16 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 30 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 23 },
  { disease: "Brucellosis", sex: "FEMALE", age: 51 },
  { disease: "Blepharospasm", sex: "MALE", age: 63 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 61 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 59 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 37 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 3 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 15 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 20 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 59 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 14 },
  { disease: "Arrhythmias", sex: "MALE", age: 0 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 62 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "MALE", age: 17 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 17 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 7 },
  { disease: "Spontaneous Pneumothorax", sex: "FEMALE", age: 18 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 17 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 43 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "MALE", age: 9 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 15 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 0 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 67 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 20 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 54 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 21 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 13 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 13 },
  { disease: "Renal Stones", sex: "FEMALE", age: 53 },
  { disease: "Bladder Cancer", sex: "MALE", age: 66 },
  { disease: "Brucellosis", sex: "MALE", age: 26 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 18 },
  { disease: "Glaucoma", sex: "FEMALE", age: 68 },
  { disease: "Bladder Cancer", sex: "MALE", age: 62 },
  { disease: "Renal Stones", sex: "FEMALE", age: 78 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 18 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 12 },
  { disease: "Glaucoma", sex: "MALE", age: 73 },
  { disease: "Glaucoma", sex: "FEMALE", age: 51 },
  { disease: "Drug Intoxication", sex: "MALE", age: 21 },
  { disease: "Glaucoma", sex: "MALE", age: 60 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 5 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 15 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 38 },
  { disease: "Down Syndrome", sex: "MALE", age: 1 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 56 },
  { disease: "Glaucoma", sex: "MALE", age: 70 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 63 },
  { disease: "Drug Intoxication", sex: "MALE", age: 25 },
  { disease: "Renal Stones", sex: "MALE", age: 65 },
  { disease: "Renal Stones", sex: "MALE", age: 65 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 33 },
  { disease: "Drug Intoxication", sex: "MALE", age: 25 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 30 },
  { disease: "Acute Pancreatitis", sex: "FEMALE", age: 78 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 7 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 31 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 7 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 14 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 16 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 13 },
  { disease: "Anaphylaxis", sex: "MALE", age: 28 },
  { disease: "Bladder Cancer", sex: "MALE", age: 83 },
  { disease: "Renal Stones", sex: "FEMALE", age: 48 },
  { disease: "Renal Stones", sex: "FEMALE", age: 44 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 64 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 67 },
  { disease: "Renal Stones", sex: "MALE", age: 42 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 57 },
  { disease: "Chronic Hepatitis B", sex: "FEMALE", age: 35 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 29 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 72 },
  { disease: "Hypertension", sex: "FEMALE", age: 50 },
  { disease: "Hypertension", sex: "MALE", age: 73 },
  { disease: "Hypertension", sex: "FEMALE", age: 67 },
  { disease: "Hypertension", sex: "MALE", age: 65 },
  { disease: "Liver Cancer", sex: "MALE", age: 79 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 13 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 13 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 9 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "MALE", age: 11 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 12 },
  { disease: "Liver Cancer", sex: "MALE", age: 63 },
  { disease: "Hypertension", sex: "FEMALE", age: 57 },
  { disease: "Hypertension", sex: "MALE", age: 56 },
  { disease: "Glaucoma", sex: "MALE", age: 67 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 79 },
  { disease: "Familial Mediterranean Fever", sex: "FEMALE", age: 19 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 51 },
  { disease: "Hypertension", sex: "FEMALE", age: 44 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 63 },
  { disease: "Acute Pancreatitis", sex: "FEMALE", age: 51 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 17 },
  { disease: "Hypertension", sex: "MALE", age: 57 },
  { disease: "Glaucoma", sex: "MALE", age: 73 },
  { disease: "Hypertension", sex: "MALE", age: 57 },
  { disease: "Glaucoma", sex: "FEMALE", age: 73 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 68 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 73 },
  { disease: "Glaucoma", sex: "FEMALE", age: 80 },
  { disease: "Glaucoma", sex: "FEMALE", age: 59 },
  { disease: "Periodontitis", sex: "FEMALE", age: 29 },
  { disease: "Hypertension", sex: "FEMALE", age: 54 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 48 },
  { disease: "ANCA-Associated Vasculitis", sex: "MALE", age: 43 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 41 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 48 },
  { disease: "Atypical Parkinsonism", sex: "FEMALE", age: 55 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 57 },
  { disease: "Glaucoma", sex: "FEMALE", age: 80 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 45 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 73 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 35 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 47 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 41 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 11 },
  { disease: "ANCA-Associated Vasculitis", sex: "FEMALE", age: 32 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 58 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 28 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 22 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 80 },
  { disease: "Hypertension", sex: "MALE", age: 31 },
  { disease: "Periodontitis", sex: "MALE", age: 22 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 80 },
  { disease: "Hypertension", sex: "FEMALE", age: 75 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 73 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 73 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 60 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 61 },
  { disease: "Atypical Parkinsonism", sex: "FEMALE", age: 71 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 20 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 52 },
  { disease: "Leukemia", sex: "FEMALE", age: 41 },
  { disease: "Leukemia", sex: "MALE", age: 42 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 4 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 5 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 60 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 11 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 44 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 7 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 31 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 68 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 11 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 72 },
  { disease: "Sudden Hearing Loss", sex: "FEMALE", age: 1 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 16 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 12 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 3 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 5 },
  { disease: "Frontotemporal Dementia", sex: "MALE", age: 63 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 70 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 24 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 26 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 69 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 14 },
  { disease: "Drug Intoxication", sex: "MALE", age: 27 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 24 },
  { disease: "Anaphylaxis", sex: "FEMALE", age: 40 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 71 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 49 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 16 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 5 },
  { disease: "Glaucoma", sex: "MALE", age: 67 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 46 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 10 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 17 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 83 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 7 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 4 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 12 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 17 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 70 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 37 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 2 },
  { disease: "Carbon Monoxide Poisoning", sex: "MALE", age: 52 },
  { disease: "Anaphylaxis", sex: "MALE", age: 52 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 21 },
  { disease: "Anaphylaxis", sex: "FEMALE", age: 29 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 20 },
  { disease: "Glaucoma", sex: "MALE", age: 57 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 4 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 71 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 26 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 58 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 68 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 28 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 33 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 62 },
  { disease: "Carbon Monoxide Poisoning", sex: "MALE", age: 45 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 68 },
  { disease: "Down Syndrome", sex: "MALE", age: 9 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 50 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 70 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "FEMALE", age: 80 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 63 },
  { disease: "Bladder Cancer", sex: "MALE", age: 61 },
  { disease: "Bladder Cancer", sex: "MALE", age: 78 },
  { disease: "Renal Stones", sex: "MALE", age: 21 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 19 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 16 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 16 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 5 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 69 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 8 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 61 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 68 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 7 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "FEMALE", age: 79 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 80 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 19 },
  { disease: "Down Syndrome", sex: "MALE", age: 12 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 75 },
  { disease: "Gonarthrosis", sex: "MALE", age: 60 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 60 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 58 },
  { disease: "Renal Stones", sex: "MALE", age: 59 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 65 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 16 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 64 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 64 },
  { disease: "Drug Intoxication", sex: "MALE", age: 22 },
  { disease: "Leukemia", sex: "FEMALE", age: 34 },
  { disease: "Down Syndrome", sex: "FEMALE", age: 8 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 10 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 13 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 82 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 19 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 70 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 50 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 59 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 69 },
  { disease: "Renal Stones", sex: "MALE", age: 41 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 75 },
  { disease: "Renal Stones", sex: "MALE", age: 68 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 70 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 59 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 11 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 64 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "FEMALE", age: 68 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 76 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "FEMALE", age: 91 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "MALE", age: 14 },
  { disease: "Down Syndrome", sex: "FEMALE", age: 0 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 62 },
  { disease: "Anaphylaxis", sex: "FEMALE", age: 55 },
  { disease: "Gonarthrosis", sex: "MALE", age: 64 },
  { disease: "Diabetic Complications", sex: "MALE", age: 79 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 54 },
  { disease: "Renal Stones", sex: "MALE", age: 48 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 40 },
  { disease: "Bladder Cancer", sex: "FEMALE", age: 62 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 20 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 63 },
  { disease: "Frontotemporal Dementia", sex: "MALE", age: 61 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 66 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 16 },
  { disease: "Lung Cancer", sex: "MALE", age: 58 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 69 },
  { disease: "Bladder Cancer", sex: "MALE", age: 50 },
  { disease: "Renal Stones", sex: "FEMALE", age: 28 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 17 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 74 },
  { disease: "Sudden Hearing Loss", sex: "FEMALE", age: 11 },
  { disease: "Renal Stones", sex: "FEMALE", age: 39 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 17 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 10 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 15 },
  { disease: "Renal Stones", sex: "MALE", age: 36 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 15 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 23 },
  { disease: "Renal Stones", sex: "FEMALE", age: 40 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 60 },
  { disease: "Bladder Cancer", sex: "MALE", age: 68 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 78 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 39 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 51 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 20 },
  { disease: "Major Depressive Disorder", sex: "MALE", age: 53 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 50 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "FEMALE", age: 80 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 48 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 61 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 7 },
  { disease: "Renal Stones", sex: "MALE", age: 42 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 14 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 64 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 57 },
  { disease: "Anaphylaxis", sex: "MALE", age: 61 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 9 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 53 },
  { disease: "Bladder Cancer", sex: "MALE", age: 75 },
  { disease: "Frontotemporal Dementia", sex: "MALE", age: 94 },
  { disease: "Frontotemporal Dementia", sex: "MALE", age: 72 },
  { disease: "Leukemia", sex: "MALE", age: 65 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 21 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 4 },
  { disease: "Acute Poststreptococcal Glomerulonephritis", sex: "MALE", age: 3 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 41 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 57 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 60 },
  { disease: "Brucellosis", sex: "FEMALE", age: 46 },
  { disease: "Anaphylaxis", sex: "MALE", age: 25 },
  { disease: "Drug Intoxication", sex: "MALE", age: 34 },
  { disease: "Bladder Cancer", sex: "MALE", age: 67 },
  { disease: "Anaphylaxis", sex: "MALE", age: 38 },
  { disease: "Renal Stones", sex: "MALE", age: 56 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 44 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 17 },
  { disease: "Lung Cancer", sex: "MALE", age: 77 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 44 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 9 },
  { disease: "Bladder Cancer", sex: "MALE", age: 51 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 7 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 18 },
  { disease: "Periodontitis", sex: "FEMALE", age: 19 },
  { disease: "Lung Cancer", sex: "MALE", age: 61 },
  { disease: "Renal Stones", sex: "MALE", age: 50 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 40 },
  { disease: "Sudden Hearing Loss", sex: "FEMALE", age: 28 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 22 },
  { disease: "Drug Intoxication", sex: "MALE", age: 37 },
  { disease: "Drug Intoxication", sex: "MALE", age: 19 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 48 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 13 },
  { disease: "Leukemia", sex: "FEMALE", age: 64 },
  { disease: "Down Syndrome", sex: "FEMALE", age: 0 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 11 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 13 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 14 },
  { disease: "Diabetic Complications", sex: "FEMALE", age: 49 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 14 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 9 },
  { disease: "Renal Stones", sex: "MALE", age: 47 },
  { disease: "Bladder Cancer", sex: "MALE", age: 70 },
  { disease: "Down Syndrome", sex: "MALE", age: 3 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 12 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 12 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 15 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 17 },
  { disease: "Down Syndrome", sex: "MALE", age: 0 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 23 },
  { disease: "Leukemia", sex: "FEMALE", age: 31 },
  { disease: "Sudden Hearing Loss", sex: "FEMALE", age: 27 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 5 },
  { disease: "Sudden Hearing Loss", sex: "FEMALE", age: 2 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 8 },
  { disease: "Renal Stones", sex: "MALE", age: 60 },
  { disease: "Renal Stones", sex: "MALE", age: 47 },
  { disease: "Renal Stones", sex: "MALE", age: 55 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 68 },
  { disease: "Renal Stones", sex: "MALE", age: 81 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 11 },
  { disease: "Carbon Monoxide Poisoning", sex: "MALE", age: 73 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 61 },
  { disease: "Carbon Monoxide Poisoning", sex: "MALE", age: 71 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 29 },
  { disease: "Renal Stones", sex: "MALE", age: 42 },
  { disease: "Leukemia", sex: "MALE", age: 70 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 49 },
  { disease: "Carbon Monoxide Poisoning", sex: "FEMALE", age: 47 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 29 },
  { disease: "Periodontitis", sex: "MALE", age: 23 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 69 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 15 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 11 },
  { disease: "Lung Cancer", sex: "MALE", age: 58 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 16 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 34 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 15 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 17 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 15 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 70 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 70 },
  { disease: "Bladder Cancer", sex: "MALE", age: 69 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 12 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 60 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 63 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 8 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 10 },
  { disease: "Blepharospasm", sex: "MALE", age: 64 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 13 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 16 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 14 },
  { disease: "Diabetic Complications", sex: "MALE", age: 54 },
  { disease: "Diabetic Complications", sex: "FEMALE", age: 62 },
  { disease: "Asthma", sex: "MALE", age: 7 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 10 },
  { disease: "Asthma", sex: "MALE", age: 11 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 15 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 13 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 76 },
  { disease: "Liver Cancer", sex: "MALE", age: 66 },
  { disease: "Liver Cancer", sex: "MALE", age: 62 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 16 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 15 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 13 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 10 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 74 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 15 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 14 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 8 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 9 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 12 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 15 },
  { disease: "Asthma", sex: "FEMALE", age: 14 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 14 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 7 },
  { disease: "Febrile Convulsion", sex: "MALE", age: 2 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 12 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 15 },
  { disease: "Diabetic Complications", sex: "MALE", age: 53 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 16 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 4 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 8 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 15 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 14 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 16 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 16 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 12 },
  { disease: "Febrile Convulsion", sex: "MALE", age: 4 },
  { disease: "Febrile Convulsion", sex: "MALE", age: 1 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 12 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 4 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 21 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 12 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 16 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 14 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 13 },
  { disease: "Arrhythmias", sex: "MALE", age: 11 },
  { disease: "Liver Cancer", sex: "MALE", age: 31 },
  { disease: "Liver Cancer", sex: "MALE", age: 51 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 9 },
  { disease: "Febrile Convulsion", sex: "MALE", age: 2 },
  { disease: "Asthma", sex: "MALE", age: 8 },
  { disease: "Febrile Convulsion", sex: "FEMALE", age: 1 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 16 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 5 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 17 },
  { disease: "Familial Mediterranean Fever", sex: "MALE", age: 9 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 15 },
  { disease: "Asthma", sex: "MALE", age: 6 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 6 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 7 },
  { disease: "Sudden Hearing Loss", sex: "FEMALE", age: 57 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 27 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 13 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 11 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 17 },
  { disease: "Asthma", sex: "MALE", age: 17 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 1 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 16 },
  { disease: "Renal Stones", sex: "MALE", age: 48 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 0 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 8 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 37 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 22 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 44 },
  { disease: "Febrile Convulsion", sex: "FEMALE", age: 5 },
  { disease: "Down Syndrome", sex: "MALE", age: 0 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 62 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 48 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 3 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 50 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 61 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 47 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 66 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 11 },
  { disease: "Liver Cancer", sex: "MALE", age: 57 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 59 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 14 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 12 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 16 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 12 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 53 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 59 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 20 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 15 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 56 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 58 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 54 },
  { disease: "Apical Dental Abscess", sex: "MALE", age: 18 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 49 },
  { disease: "Glaucoma", sex: "MALE", age: 55 },
  { disease: "Glaucoma", sex: "MALE", age: 65 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 78 },
  { disease: "Vesicoureteral Reflux", sex: "MALE", age: 1 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 7 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 66 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 10 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 6 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Febrile Convulsion", sex: "MALE", age: 3 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 24 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 6 },
  { disease: "Spontaneous Pneumothorax", sex: "FEMALE", age: 42 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 16 },
  { disease: "Major Depressive Disorder", sex: "MALE", age: 38 },
  { disease: "Diabetic Complications", sex: "MALE", age: 48 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 67 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 39 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 75 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 10 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 0 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 3 },
  { disease: "Vesicoureteral Reflux", sex: "FEMALE", age: 4 },
  { disease: "Asthma", sex: "MALE", age: 6 },
  { disease: "Atopic Dermatitis", sex: "FEMALE", age: 1 },
  { disease: "Asthma", sex: "FEMALE", age: 5 },
  { disease: "Asthma", sex: "MALE", age: 10 },
  { disease: "Asthma", sex: "FEMALE", age: 4 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 10 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 11 },
  { disease: "Asthma", sex: "MALE", age: 7 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 15 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 7 },
  { disease: "Asthma", sex: "MALE", age: 9 },
  { disease: "Atopic Dermatitis", sex: "MALE", age: 0 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 6 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 3 },
  { disease: "Periodontitis", sex: "FEMALE", age: 38 },
  { disease: "Periodontitis", sex: "FEMALE", age: 34 },
  { disease: "Periodontitis", sex: "MALE", age: 54 },
  { disease: "Periodontitis", sex: "FEMALE", age: 40 },
  { disease: "Periodontitis", sex: "MALE", age: 64 },
  { disease: "Colon Volvulus", sex: "MALE", age: 75 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 79 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 58 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 58 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 75 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Periodontitis", sex: "FEMALE", age: 41 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 5 },
  { disease: "Periodontitis", sex: "FEMALE", age: 56 },
  { disease: "Congenital Deafness", sex: "MALE", age: 4 },
  { disease: "First-Episode Psychosis", sex: "FEMALE", age: 47 },
  { disease: "Colon Volvulus", sex: "MALE", age: 68 },
  { disease: "Gynecomastia", sex: "MALE", age: 12 },
  { disease: "Congenital Deafness", sex: "MALE", age: 1 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 9 },
  { disease: "Colon Volvulus", sex: "MALE", age: 72 },
  { disease: "Gynecomastia", sex: "MALE", age: 16 },
  { disease: "Periodontitis", sex: "FEMALE", age: 43 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 3 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Congenital Deafness", sex: "MALE", age: 2 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 40 },
  { disease: "Lymphoma", sex: "MALE", age: 67 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 13 },
  { disease: "Colon Volvulus", sex: "FEMALE", age: 67 },
  { disease: "Gynecomastia", sex: "MALE", age: 17 },
  { disease: "Colon Volvulus", sex: "FEMALE", age: 60 },
  { disease: "Scleroderma", sex: "MALE", age: 44 },
  { disease: "Scleroderma", sex: "MALE", age: 72 },
  { disease: "Polycystic Kidney Disease", sex: "FEMALE", age: 57 },
  { disease: "Scleroderma", sex: "FEMALE", age: 57 },
  { disease: "Scleroderma", sex: "FEMALE", age: 50 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 15 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 46 },
  { disease: "Congenital Deafness", sex: "MALE", age: 1 },
  { disease: "Scleroderma", sex: "FEMALE", age: 52 },
  { disease: "Scleroderma", sex: "FEMALE", age: 25 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 25 },
  { disease: "Scleroderma", sex: "MALE", age: 21 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 32 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 23 },
  { disease: "Scleroderma", sex: "FEMALE", age: 74 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 46 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 54 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 35 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 48 },
  { disease: "Scleroderma", sex: "MALE", age: 37 },
  { disease: "Scleroderma", sex: "FEMALE", age: 51 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 32 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 30 },
  { disease: "Scleroderma", sex: "FEMALE", age: 38 },
  { disease: "Colon Volvulus", sex: "FEMALE", age: 92 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 42 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 3 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 5 },
  { disease: "Scleroderma", sex: "FEMALE", age: 44 },
  { disease: "Periodontitis", sex: "MALE", age: 54 },
  { disease: "First-Episode Psychosis", sex: "FEMALE", age: 46 },
  { disease: "First-Episode Psychosis", sex: "FEMALE", age: 25 },
  { disease: "First-Episode Psychosis", sex: "FEMALE", age: 43 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 8 },
  { disease: "Congenital Deafness", sex: "MALE", age: 3 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 34 },
  { disease: "Gynecomastia", sex: "MALE", age: 13 },
  { disease: "Periodontitis", sex: "FEMALE", age: 23 },
  { disease: "Congenital Deafness", sex: "MALE", age: 16 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 8 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "MALE", age: 0 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "FEMALE", age: 0 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 9 },
  { disease: "Gynecomastia", sex: "MALE", age: 14 },
  { disease: "Gynecomastia", sex: "MALE", age: 12 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 4 },
  { disease: "Gynecomastia", sex: "MALE", age: 15 },
  { disease: "Colon Volvulus", sex: "FEMALE", age: 37 },
  { disease: "First-Episode Psychosis", sex: "FEMALE", age: 34 },
  { disease: "Gynecomastia", sex: "MALE", age: 15 },
  { disease: "First-Episode Psychosis", sex: "FEMALE", age: 19 },
  { disease: "Colon Volvulus", sex: "MALE", age: 61 },
  { disease: "Colon Volvulus", sex: "FEMALE", age: 21 },
  { disease: "Colon Volvulus", sex: "MALE", age: 65 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 8 },
  { disease: "Periodontitis", sex: "FEMALE", age: 37 },
  { disease: "Gynecomastia", sex: "MALE", age: 16 },
  { disease: "Gynecomastia", sex: "MALE", age: 12 },
  { disease: "First-Episode Psychosis", sex: "MALE", age: 18 },
  { disease: "Gynecomastia", sex: "MALE", age: 11 },
  { disease: "Colon Volvulus", sex: "MALE", age: 75 },
  { disease: "Tuberculosis", sex: "MALE", age: 35 },
  { disease: "Congenital Deafness", sex: "MALE", age: 1 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 5 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 2 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "FEMALE", age: 0 },
  { disease: "Gynecomastia", sex: "MALE", age: 14 },
  { disease: "Gynecomastia", sex: "MALE", age: 14 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "MALE", age: 0 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "MALE", age: 0 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 72 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "MALE", age: 0 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 11 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 40 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 59 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 29 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 40 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 18 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 14 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 55 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 51 },
  { disease: "First-Episode Psychosis", sex: "MALE", age: 33 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 74 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 84 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 85 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 42 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 57 },
  { disease: "Colon Volvulus", sex: "MALE", age: 86 },
  { disease: "Lymphoma", sex: "FEMALE", age: 20 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 49 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 59 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 10 },
  { disease: "Gynecomastia", sex: "MALE", age: 12 },
  { disease: "Neurofibromatosis", sex: "FEMALE", age: 11 },
  { disease: "Lymphoma", sex: "MALE", age: 59 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 9 },
  { disease: "Gynecomastia", sex: "MALE", age: 11 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 77 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 45 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 19 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 26 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "FEMALE", age: 0 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 3 },
  { disease: "Gynecomastia", sex: "MALE", age: 14 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 17 },
  { disease: "Neurofibromatosis", sex: "FEMALE", age: 6 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 50 },
  { disease: "Neurofibromatosis", sex: "MALE", age: 35 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 46 },
  { disease: "Neurofibromatosis", sex: "FEMALE", age: 17 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 38 },
  { disease: "Colon Volvulus", sex: "MALE", age: 52 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 32 },
  { disease: "Neurofibromatosis", sex: "FEMALE", age: 10 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 73 },
  { disease: "Neurofibromatosis", sex: "MALE", age: 9 },
  { disease: "Lymphoma", sex: "FEMALE", age: 26 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 22 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 43 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 50 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 15 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 27 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 40 },
  { disease: "Neurofibromatosis", sex: "MALE", age: 4 },
  { disease: "Neurofibromatosis", sex: "FEMALE", age: 30 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 68 },
  { disease: "Neurofibromatosis", sex: "MALE", age: 28 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 16 },
  { disease: "Neurofibromatosis", sex: "MALE", age: 12 },
  { disease: "Lymphoma", sex: "FEMALE", age: 37 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 29 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 7 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 8 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 63 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 42 },
  { disease: "Gynecomastia", sex: "MALE", age: 15 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 52 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 54 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 68 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 24 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 22 },
  { disease: "Bile Duct Cancer", sex: "MALE", age: 68 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 59 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 73 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 96 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 72 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 70 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 69 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 54 },
  { disease: "Colon Volvulus", sex: "MALE", age: 74 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 13 },
  { disease: "Neurofibromatosis", sex: "FEMALE", age: 12 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 49 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 68 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 60 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 2 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 41 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 18 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 2 },
  { disease: "Gynecomastia", sex: "MALE", age: 12 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 8 },
  { disease: "Gynecomastia", sex: "MALE", age: 17 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 11 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 66 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 8 },
  { disease: "Colon Volvulus", sex: "MALE", age: 63 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 67 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 68 },
  { disease: "Lymphoma", sex: "MALE", age: 42 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 72 },
  { disease: "Lymphoma", sex: "MALE", age: 35 },
  { disease: "Bile Duct Cancer", sex: "MALE", age: 63 },
  { disease: "Lymphoma", sex: "MALE", age: 70 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "MALE", age: 0 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "FEMALE", age: 0 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 38 },
  { disease: "Lymphoma", sex: "FEMALE", age: 23 },
  { disease: "Congenital Deafness", sex: "MALE", age: 0 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "MALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 39 },
  { disease: "Gynecomastia", sex: "MALE", age: 15 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Gynecomastia", sex: "MALE", age: 14 },
  { disease: "Gynecomastia", sex: "MALE", age: 11 },
  { disease: "Gynecomastia", sex: "MALE", age: 12 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 1 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "MALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Gynecomastia", sex: "MALE", age: 16 },
  { disease: "Lung Cancer", sex: "MALE", age: 64 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 17 },
  { disease: "Lung Cancer", sex: "MALE", age: 65 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 17 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 37 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 71 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 59 },
  { disease: "Lung Cancer", sex: "MALE", age: 78 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 7 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 8 },
  { disease: "Lung Cancer", sex: "MALE", age: 69 },
  { disease: "Lung Cancer", sex: "MALE", age: 72 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 77 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 60 },
  { disease: "Lung Cancer", sex: "MALE", age: 86 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 17 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 9 },
  { disease: "Lung Cancer", sex: "MALE", age: 68 },
  { disease: "Lung Cancer", sex: "MALE", age: 66 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 15 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 13 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 67 },
  { disease: "Lung Cancer", sex: "MALE", age: 69 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 17 },
  { disease: "Lung Cancer", sex: "MALE", age: 72 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 61 },
  { disease: "Neurofibromatosis", sex: "FEMALE", age: 21 },
  { disease: "Neurofibromatosis", sex: "FEMALE", age: 57 },
  { disease: "Mitral Valve Prolapse", sex: "MALE", age: 8 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 55 },
  { disease: "Lung Cancer", sex: "MALE", age: 61 },
  { disease: "Lung Cancer", sex: "MALE", age: 60 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 70 },
  { disease: "Essential Tremor", sex: "MALE", age: 64 },
  { disease: "Blepharospasm", sex: "FEMALE", age: 53 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 79 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 56 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Lung Cancer", sex: "MALE", age: 63 },
  { disease: "Essential Tremor", sex: "MALE", age: 75 },
  { disease: "Gonarthrosis", sex: "MALE", age: 77 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 70 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 72 },
  { disease: "Gonarthrosis", sex: "MALE", age: 82 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 66 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 10 },
  { disease: "Lung Cancer", sex: "MALE", age: 61 },
  { disease: "Essential Tremor", sex: "MALE", age: 57 },
  { disease: "Epilepsy", sex: "FEMALE", age: 63 },
  { disease: "Lung Cancer", sex: "MALE", age: 82 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 76 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 64 },
  { disease: "Essential Tremor", sex: "MALE", age: 22 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Neurofibromatosis", sex: "FEMALE", age: 21 },
  { disease: "Epilepsy", sex: "FEMALE", age: 22 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 65 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 38 },
  { disease: "Periodontitis", sex: "FEMALE", age: 18 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 48 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 67 },
  { disease: "Pancreatic Cancer", sex: "MALE", age: 42 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 72 },
  { disease: "Sudden Hearing Loss", sex: "FEMALE", age: 59 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 83 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 74 },
  { disease: "Neurofibromatosis", sex: "FEMALE", age: 14 },
  { disease: "Lung Cancer", sex: "MALE", age: 74 },
  { disease: "Periodontitis", sex: "FEMALE", age: 19 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 62 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 65 },
  { disease: "Gonarthrosis", sex: "MALE", age: 61 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 76 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 55 },
  { disease: "Lung Cancer", sex: "MALE", age: 58 },
  { disease: "Pancreatic Cancer", sex: "FEMALE", age: 61 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 57 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 7 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 70 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 82 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 62 },
  { disease: "Sudden Hearing Loss", sex: "MALE", age: 4 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 65 },
  { disease: "Lung Cancer", sex: "MALE", age: 58 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 59 },
  { disease: "Epilepsy", sex: "MALE", age: 29 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 59 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 61 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 50 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 68 },
  { disease: "Lung Cancer", sex: "MALE", age: 72 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 66 },
  { disease: "Epilepsy", sex: "FEMALE", age: 39 },
  { disease: "Epilepsy", sex: "MALE", age: 18 },
  { disease: "Epilepsy", sex: "FEMALE", age: 25 },
  { disease: "Epilepsy", sex: "FEMALE", age: 30 },
  { disease: "Epilepsy", sex: "FEMALE", age: 22 },
  { disease: "Epilepsy", sex: "FEMALE", age: 21 },
  { disease: "Epilepsy", sex: "MALE", age: 25 },
  { disease: "Epilepsy", sex: "FEMALE", age: 35 },
  { disease: "Down Syndrome", sex: "MALE", age: 0 },
  { disease: "Nocturnal Enuresis", sex: "MALE", age: 8 },
  { disease: "Nocturnal Enuresis", sex: "FEMALE", age: 10 },
  { disease: "Nocturnal Enuresis", sex: "MALE", age: 7 },
  { disease: "Bipolar Disorder", sex: "FEMALE", age: 24 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 68 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 74 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 54 },
  { disease: "Lung Cancer", sex: "MALE", age: 47 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 76 },
  { disease: "Lung Cancer", sex: "MALE", age: 71 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 79 },
  { disease: "Essential Tremor", sex: "MALE", age: 74 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 57 },
  { disease: "Lung Cancer", sex: "MALE", age: 73 },
  { disease: "Lung Cancer", sex: "MALE", age: 69 },
  { disease: "Lung Cancer", sex: "MALE", age: 60 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 71 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 82 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 60 },
  { disease: "First-Episode Psychosis", sex: "MALE", age: 41 },
  { disease: "Essential Tremor", sex: "MALE", age: 50 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 48 },
  { disease: "Pyelonephritis", sex: "MALE", age: 48 },
  { disease: "Pyelonephritis", sex: "MALE", age: 72 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 67 },
  { disease: "Lung Cancer", sex: "FEMALE", age: 64 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 79 },
  { disease: "Epilepsy", sex: "MALE", age: 25 },
  { disease: "Epilepsy", sex: "MALE", age: 38 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 49 },
  { disease: "Lung Cancer", sex: "MALE", age: 52 },
  { disease: "Down Syndrome", sex: "FEMALE", age: 3 },
  { disease: "Gonarthrosis", sex: "MALE", age: 61 },
  { disease: "Pyelonephritis", sex: "MALE", age: 88 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 75 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 55 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 46 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 57 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 74 },
  { disease: "Essential Tremor", sex: "MALE", age: 82 },
  { disease: "Epilepsy", sex: "FEMALE", age: 21 },
  { disease: "Epilepsy", sex: "MALE", age: 43 },
  { disease: "Epilepsy", sex: "FEMALE", age: 38 },
  { disease: "Epilepsy", sex: "FEMALE", age: 21 },
  { disease: "Epilepsy", sex: "FEMALE", age: 21 },
  { disease: "Epilepsy", sex: "FEMALE", age: 30 },
  { disease: "Lung Cancer", sex: "FEMALE", age: 59 },
  { disease: "Sudden Hearing Loss", sex: "FEMALE", age: 15 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "FEMALE", age: 0 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 15 },
  { disease: "Nocturnal Enuresis", sex: "MALE", age: 12 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 8 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 14 },
  { disease: "Childhood Hashimoto's Thyroiditis", sex: "FEMALE", age: 16 },
  { disease: "Colon Volvulus", sex: "MALE", age: 69 },
  { disease: "Hypertension", sex: "FEMALE", age: 56 },
  { disease: "Hypertension", sex: "FEMALE", age: 62 },
  { disease: "Hypertension", sex: "FEMALE", age: 79 },
  { disease: "Hypertension", sex: "FEMALE", age: 69 },
  { disease: "Hypertension", sex: "FEMALE", age: 72 },
  { disease: "Hypertension", sex: "FEMALE", age: 72 },
  { disease: "Hypertension", sex: "FEMALE", age: 73 },
  { disease: "Hypertension", sex: "FEMALE", age: 51 },
  { disease: "Hypertension", sex: "MALE", age: 76 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 1 },
  { disease: "Lung Cancer", sex: "MALE", age: 70 },
  { disease: "Colon Volvulus", sex: "MALE", age: 85 },
  { disease: "Congenital Deafness", sex: "MALE", age: 2 },
  { disease: "Colon Volvulus", sex: "MALE", age: 69 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 9 },
  { disease: "Gynecomastia", sex: "MALE", age: 16 },
  { disease: "First-Episode Psychosis", sex: "MALE", age: 22 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Gynecomastia", sex: "MALE", age: 15 },
  { disease: "First-Episode Psychosis", sex: "MALE", age: 31 },
  { disease: "Gynecomastia", sex: "MALE", age: 15 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 9 },
  { disease: "Lymphoma", sex: "MALE", age: 52 },
  { disease: "Bile Duct Cancer", sex: "FEMALE", age: 59 },
  { disease: "Gynecomastia", sex: "MALE", age: 11 },
  { disease: "Bile Duct Cancer", sex: "MALE", age: 76 },
  { disease: "First-Episode Psychosis", sex: "FEMALE", age: 16 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 9 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 3 },
  { disease: "Bladder Cancer", sex: "MALE", age: 76 },
  { disease: "Bladder Cancer", sex: "MALE", age: 83 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 16 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 12 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 16 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 17 },
  { disease: "Prostate Cancer", sex: "MALE", age: 67 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 45 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 15 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 38 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 26 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 16 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 12 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 15 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 11 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 16 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 9 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 14 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 9 },
  { disease: "Arrhythmias", sex: "MALE", age: 9 },
  { disease: "Arrhythmias", sex: "FEMALE", age: 9 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 10 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 4 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 60 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 15 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 6 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 10 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 42 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 27 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 55 },
  { disease: "Diabetic Complications", sex: "FEMALE", age: 55 },
  { disease: "Diabetic Complications", sex: "FEMALE", age: 57 },
  { disease: "Diabetic Complications", sex: "MALE", age: 59 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 62 },
  { disease: "Bladder Cancer", sex: "MALE", age: 60 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 21 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 39 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 50 },
  { disease: "Bladder Cancer", sex: "MALE", age: 78 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 13 },
  { disease: "Prostate Cancer", sex: "MALE", age: 88 },
  { disease: "Diabetic Complications", sex: "MALE", age: 65 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 14 },
  { disease: "Bladder Cancer", sex: "MALE", age: 59 },
  { disease: "Bladder Cancer", sex: "MALE", age: 74 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 8 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 61 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 29 },
  { disease: "Bladder Cancer", sex: "MALE", age: 79 },
  { disease: "Lung Cancer", sex: "MALE", age: 75 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 54 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 10 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 61 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 66 },
  { disease: "Bladder Cancer", sex: "MALE", age: 64 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 36 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 68 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 66 },
  { disease: "Mitral Valve Prolapse", sex: "FEMALE", age: 11 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 17 },
  { disease: "Prostate Cancer", sex: "MALE", age: 70 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 6 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 22 },
  { disease: "Major Depressive Disorder", sex: "FEMALE", age: 19 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 68 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 72 },
  { disease: "Pulmonary Embolism", sex: "MALE", age: 61 },
  { disease: "Pulmonary Embolism", sex: "FEMALE", age: 83 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 83 },
  { disease: "Childhood Renal Stones", sex: "FEMALE", age: 0 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 8 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 62 },
  { disease: "Bladder Cancer", sex: "MALE", age: 63 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 15 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 12 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 12 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 12 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 5 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 11 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 10 },
  { disease: "Bladder Cancer", sex: "MALE", age: 74 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 65 },
  { disease: "Bladder Cancer", sex: "MALE", age: 41 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 13 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 13 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 19 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 57 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 10 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 63 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 7 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 15 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 51 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 60 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 46 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 61 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 21 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 21 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 26 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 8 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 72 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 65 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 50 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 15 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 12 },
  { disease: "Arrhythmias", sex: "MALE", age: 12 },
  { disease: "Lung Cancer", sex: "MALE", age: 49 },
  { disease: "Essential Tremor", sex: "MALE", age: 65 },
  { disease: "Anaphylaxis", sex: "MALE", age: 26 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 62 },
  { disease: "Renal Stones", sex: "MALE", age: 56 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 66 },
  { disease: "Epilepsy", sex: "FEMALE", age: 23 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 17 },
  { disease: "Epilepsy", sex: "FEMALE", age: 27 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 24 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 60 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 13 },
  { disease: "Brucellosis", sex: "MALE", age: 35 },
  { disease: "Epilepsy", sex: "FEMALE", age: 18 },
  { disease: "Essential Tremor", sex: "MALE", age: 66 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 9 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 2 },
  { disease: "Leukemia", sex: "MALE", age: 61 },
  { disease: "Childhood Hypothyroidism", sex: "MALE", age: 6 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 71 },
  { disease: "Diabetic Complications", sex: "FEMALE", age: 68 },
  { disease: "Epilepsy", sex: "FEMALE", age: 31 },
  { disease: "Pyelonephritis", sex: "FEMALE", age: 79 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "MALE", age: 59 },
  { disease: "Glaucoma", sex: "MALE", age: 43 },
  { disease: "Pyelonephritis", sex: "FEMALE", age: 27 },
  { disease: "Rotator Cuff Tear", sex: "MALE", age: 52 },
  { disease: "Childhood Hypothyroidism", sex: "MALE", age: 10 },
  { disease: "Diabetic Complications", sex: "FEMALE", age: 74 },
  { disease: "Major Depressive Disorder", sex: "MALE", age: 16 },
  { disease: "Epilepsy", sex: "MALE", age: 20 },
  { disease: "Epilepsy", sex: "FEMALE", age: 31 },
  { disease: "Sudden Hearing Loss", sex: "FEMALE", age: 51 },
  { disease: "Scoliosis", sex: "FEMALE", age: 41 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 71 },
  { disease: "Renal Stones", sex: "MALE", age: 56 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 63 },
  { disease: "Renal Stones", sex: "MALE", age: 55 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 26 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 43 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 60 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 72 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 26 },
  { disease: "Bronchopulmonary Dysplasia", sex: "FEMALE", age: 0 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 33 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 50 },
  { disease: "Acute Rheumatic Fever", sex: "FEMALE", age: 16 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 75 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 43 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 24 },
  { disease: "Bronchopulmonary Dysplasia", sex: "MALE", age: 0 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 17 },
  { disease: "Asthma", sex: "FEMALE", age: 54 },
  { disease: "Renal Stones", sex: "MALE", age: 60 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 17 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 22 },
  { disease: "Habitual Abortion", sex: "MALE", age: 34 },
  { disease: "Habitual Abortion", sex: "MALE", age: 29 },
  { disease: "Renal Stones", sex: "MALE", age: 32 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 36 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 52 },
  { disease: "Renal Stones", sex: "MALE", age: 34 },
  { disease: "Renal Stones", sex: "MALE", age: 44 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 55 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 82 },
  { disease: "First-Episode Psychosis", sex: "FEMALE", age: 24 },
  { disease: "First-Episode Psychosis", sex: "FEMALE", age: 60 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 74 },
  { disease: "Renal Stones", sex: "FEMALE", age: 29 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 25 },
  { disease: "Habitual Abortion", sex: "MALE", age: 29 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 25 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 68 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 84 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 8 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 12 },
  { disease: "Renal Stones", sex: "FEMALE", age: 56 },
  { disease: "Renal Stones", sex: "MALE", age: 52 },
  { disease: "Habitual Abortion", sex: "MALE", age: 24 },
  { disease: "Hydatid Cyst", sex: "FEMALE", age: 9 },
  { disease: "Habitual Abortion", sex: "MALE", age: 33 },
  { disease: "Stomach Cancer", sex: "MALE", age: 53 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 50 },
  { disease: "Habitual Abortion", sex: "MALE", age: 27 },
  { disease: "Nocturnal Enuresis", sex: "FEMALE", age: 12 },
  { disease: "Periodontitis", sex: "MALE", age: 25 },
  { disease: "Nonalcoholic Steatohepatitis", sex: "FEMALE", age: 60 },
  { disease: "Acute Pancreatitis", sex: "FEMALE", age: 78 },
  { disease: "Alzheimer's Disease", sex: "MALE", age: 42 },
  { disease: "Periodontitis", sex: "MALE", age: 22 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 12 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 71 },
  { disease: "Epilepsy", sex: "FEMALE", age: 35 },
  { disease: "Epilepsy", sex: "MALE", age: 24 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 7 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 71 },
  { disease: "Atypical Parkinsonism", sex: "FEMALE", age: 74 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 58 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 6 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 69 },
  { disease: "Epilepsy", sex: "MALE", age: 18 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 71 },
  { disease: "Idiopathic Direct Hyperbilirubinemia", sex: "MALE", age: 0 },
  { disease: "Gynecomastia", sex: "MALE", age: 16 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 34 },
  { disease: "Atypical Parkinsonism", sex: "FEMALE", age: 75 },
  { disease: "Gynecomastia", sex: "MALE", age: 14 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 66 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 6 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 26 },
  { disease: "Anaphylaxis", sex: "MALE", age: 52 },
  { disease: "Atypical Parkinsonism", sex: "FEMALE", age: 58 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 67 },
  { disease: "Scoliosis", sex: "FEMALE", age: 12 },
  { disease: "Gynecomastia", sex: "MALE", age: 14 },
  { disease: "Bile Duct Cancer", sex: "FEMALE", age: 57 },
  { disease: "Scoliosis", sex: "FEMALE", age: 12 },
  { disease: "Scoliosis", sex: "FEMALE", age: 14 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 59 },
  { disease: "Acute Pancreatitis", sex: "MALE", age: 61 },
  { disease: "Polycystic Kidney Disease", sex: "MALE", age: 48 },
  { disease: "Scoliosis", sex: "FEMALE", age: 11 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Scoliosis", sex: "FEMALE", age: 12 },
  { disease: "Lymphoma", sex: "FEMALE", age: 77 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 62 },
  { disease: "Gonarthrosis", sex: "MALE", age: 66 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 20 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "FEMALE", age: 63 },
  { disease: "Scoliosis", sex: "FEMALE", age: 15 },
  { disease: "Scoliosis", sex: "FEMALE", age: 14 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "MALE", age: 65 },
  { disease: "Gonarthrosis", sex: "MALE", age: 68 },
  { disease: "Atypical Parkinsonism", sex: "MALE", age: 61 },
  { disease: "Epilepsy", sex: "MALE", age: 25 },
  { disease: "Epilepsy", sex: "FEMALE", age: 30 },
  { disease: "Epilepsy", sex: "FEMALE", age: 61 },
  { disease: "Childhood Renal Stones", sex: "FEMALE", age: 0 },
  { disease: "Childhood Renal Stones", sex: "MALE", age: 15 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 20 },
  { disease: "Spontaneous Pneumothorax", sex: "MALE", age: 19 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 29 },
  { disease: "Epilepsy", sex: "FEMALE", age: 26 },
  { disease: "Epilepsy", sex: "FEMALE", age: 21 },
  { disease: "Arrhythmias", sex: "MALE", age: 17 },
  { disease: "Polycystic Kidney Disease", sex: "FEMALE", age: 53 },
  { disease: "Healthy", sex: "FEMALE", age: 24 },
  { disease: "Polycystic Kidney Disease", sex: "MALE", age: 72 },
  { disease: "Polycystic Kidney Disease", sex: "FEMALE", age: 41 },
  { disease: "Polycystic Kidney Disease", sex: "FEMALE", age: 66 },
  { disease: "Polycystic Kidney Disease", sex: "FEMALE", age: 24 },
  { disease: "Polycystic Kidney Disease", sex: "FEMALE", age: 62 },
  { disease: "Polycystic Kidney Disease", sex: "FEMALE", age: 39 },
  { disease: "Polycystic Kidney Disease", sex: "MALE", age: 48 },
  { disease: "Polycystic Kidney Disease", sex: "FEMALE", age: 31 },
  { disease: "Polycystic Kidney Disease", sex: "MALE", age: 48 },
  { disease: "Pancreatic Cancer", sex: "FEMALE", age: 73 },
  { disease: "Pancreatic Cancer", sex: "MALE", age: 58 },
  { disease: "Arrhythmias", sex: "MALE", age: 16 },
  { disease: "Arrhythmias", sex: "FEMALE", age: 16 },
  { disease: "Polycystic Kidney Disease", sex: "MALE", age: 44 },
  { disease: "Bile Duct Cancer", sex: "MALE", age: 55 },
  { disease: "Bile Duct Cancer", sex: "FEMALE", age: 59 },
  { disease: "Arrhythmias", sex: "MALE", age: 13 },
  { disease: "Pancreatic Cancer", sex: "FEMALE", age: 18 },
  { disease: "Pancreatic Cancer", sex: "MALE", age: 56 },
  { disease: "Arrhythmias", sex: "FEMALE", age: 10 },
  { disease: "Arrhythmias", sex: "FEMALE", age: 10 },
  { disease: "Pancreatic Cancer", sex: "MALE", age: 44 },
  { disease: "Bile Duct Cancer", sex: "FEMALE", age: 62 },
  { disease: "Pancreatic Cancer", sex: "FEMALE", age: 67 },
  { disease: "Arrhythmias", sex: "MALE", age: 12 },
  { disease: "Bile Duct Cancer", sex: "MALE", age: 75 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 23 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 49 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Pyelonephritis", sex: "FEMALE", age: 50 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 40 },
  { disease: "Systemic Lupus Erythematosus", sex: "FEMALE", age: 43 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Systemic Lupus Erythematosus", sex: "MALE", age: 50 },
  { disease: "Pancreatic Cancer", sex: "MALE", age: 71 },
  { disease: "Pyelonephritis", sex: "MALE", age: 56 },
  { disease: "Tuberculosis", sex: "MALE", age: 29 },
  { disease: "Pyelonephritis", sex: "FEMALE", age: 47 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Tuberculosis", sex: "FEMALE", age: 21 },
  { disease: "Tuberculosis", sex: "MALE", age: 78 },
  { disease: "Tuberculosis", sex: "MALE", age: 62 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Tuberculosis", sex: "FEMALE", age: 44 },
  { disease: "Pyelonephritis", sex: "FEMALE", age: 83 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Tuberculosis", sex: "FEMALE", age: 33 },
  { disease: "Tuberculosis", sex: "FEMALE", age: 28 },
  { disease: "Tuberculosis", sex: "MALE", age: 62 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Prostate Cancer", sex: "MALE", age: 75 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Polycystic Kidney Disease", sex: "MALE", age: 32 },
  { disease: "Asthma", sex: "FEMALE", age: 67 },
  { disease: "Leukemia", sex: "MALE", age: 45 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Polycystic Kidney Disease", sex: "MALE", age: 65 },
  { disease: "Asthma", sex: "FEMALE", age: 52 },
  { disease: "Leukemia", sex: "MALE", age: 57 },
  { disease: "Asthma", sex: "FEMALE", age: 55 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Pyelonephritis", sex: "FEMALE", age: 19 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Prostate Cancer", sex: "MALE", age: 58 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Prostate Cancer", sex: "MALE", age: 71 },
  { disease: "Prostate Cancer", sex: "MALE", age: 75 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Prostate Cancer", sex: "MALE", age: 78 },
  { disease: "Prostate Cancer", sex: "MALE", age: 75 },
  { disease: "Prostate Cancer", sex: "MALE", age: 53 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "FEMALE", age: 0 },
  { disease: "Prostate Cancer", sex: "MALE", age: 63 },
  { disease: "Prostate Cancer", sex: "MALE", age: 78 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 36 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 66 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 76 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 65 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 69 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 88 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 66 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 58 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 67 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 54 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 86 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 49 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 76 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 55 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 69 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 23 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 76 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 59 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 39 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 47 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 57 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 21 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 62 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 67 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 58 },
  { disease: "Breast Cancer", sex: "FEMALE", age: 60 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 56 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 67 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 78 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 36 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 63 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 59 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 69 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 58 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 38 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 58 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 48 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 31 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 14 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 71 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 60 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 50 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 34 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 27 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 27 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 59 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 20 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 23 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 30 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 47 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 31 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 28 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 13 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 35 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 36 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Congenital Heart Diseases", sex: "FEMALE", age: 13 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 24 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 11 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 66 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 56 },
  { disease: "Habitual Abortion", sex: "MALE", age: 33 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 60 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 74 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 63 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 63 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 44 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 55 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 71 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 32 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 56 },
  { disease: "Polycystic Ovary Syndrome", sex: "FEMALE", age: 29 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 69 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 58 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 56 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 80 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 71 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 56 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 43 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 56 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 51 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 39 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 81 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 59 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 75 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "MALE", age: 0 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 61 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 66 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 28 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 74 },
  { disease: "Colon Volvulus", sex: "MALE", age: 74 },
  { disease: "Dystonia", sex: "FEMALE", age: 24 },
  { disease: "Dystonia", sex: "MALE", age: 74 },
  { disease: "Dystonia", sex: "MALE", age: 41 },
  { disease: "Apical Dental Abscess", sex: "FEMALE", age: 22 },
  { disease: "Schizophrenia", sex: "MALE", age: 53 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 74 },
  { disease: "Leukemia", sex: "MALE", age: 58 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 62 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 22 },
  { disease: "Glaucoma", sex: "FEMALE", age: 62 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 72 },
  { disease: "Stomach Cancer", sex: "MALE", age: 60 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 67 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "FEMALE", age: 56 },
  { disease: "Stomach Cancer", sex: "FEMALE", age: 64 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 60 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 69 },
  { disease: "Brucellosis", sex: "FEMALE", age: 73 },
  { disease: "Glaucoma", sex: "FEMALE", age: 82 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 69 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 20 },
  { disease: "Brucellosis", sex: "MALE", age: 50 },
  { disease: "Leukemia", sex: "FEMALE", age: 57 },
  { disease: "Brucellosis", sex: "MALE", age: 25 },
  { disease: "Dystonia", sex: "FEMALE", age: 40 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 16 },
  { disease: "Precocious Puberty", sex: "FEMALE", age: 12 },
  { disease: "Essential Tremor", sex: "MALE", age: 52 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 67 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 64 },
  { disease: "Periodontitis", sex: "FEMALE", age: 27 },
  { disease: "Renal Stones", sex: "FEMALE", age: 43 },
  { disease: "Essential Tremor", sex: "MALE", age: 56 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 60 },
  { disease: "Pancreatic Cancer", sex: "MALE", age: 70 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 44 },
  { disease: "Bipolar Disorder", sex: "MALE", age: 26 },
  { disease: "First-Episode Psychosis", sex: "MALE", age: 23 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 55 },
  { disease: "Bladder Cancer", sex: "MALE", age: 76 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 43 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 73 },
  { disease: "Renal Stones", sex: "MALE", age: 52 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 63 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 84 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 13 },
  { disease: "Scoliosis", sex: "FEMALE", age: 14 },
  { disease: "Scoliosis", sex: "FEMALE", age: 12 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 56 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 24 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 58 },
  { disease: "Renal Stones", sex: "MALE", age: 79 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 48 },
  { disease: "Drug Intoxication", sex: "FEMALE", age: 18 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 9 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 76 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 64 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 7 },
  { disease: "Liver Cancer", sex: "FEMALE", age: 64 },
  { disease: "Liver Cancer", sex: "MALE", age: 53 },
  { disease: "Lung Cancer", sex: "MALE", age: 64 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 21 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 32 },
  { disease: "Essential Tremor", sex: "MALE", age: 39 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 51 },
  { disease: "Gonarthrosis", sex: "FEMALE", age: 50 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 74 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 63 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 55 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 42 },
  { disease: "Renal Stones", sex: "MALE", age: 32 },
  { disease: "Liver Cancer", sex: "MALE", age: 50 },
  { disease: "Epilepsy", sex: "MALE", age: 46 },
  { disease: "Scoliosis", sex: "MALE", age: 6 },
  { disease: "Asthma", sex: "FEMALE", age: 54 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 61 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 22 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 32 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 63 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 33 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 24 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 42 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 43 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 41 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 39 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 32 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 24 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 46 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 43 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 52 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 48 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 43 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 40 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 53 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 40 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 55 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 48 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 18 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 59 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 25 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 46 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 43 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 35 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 21 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 61 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 40 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 32 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 33 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 34 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 39 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 43 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 53 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 52 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 53 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 39 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 45 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 18 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 42 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 42 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 30 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 35 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 42 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 43 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 46 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 51 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 25 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 49 },
  { disease: "Ankylosing Spondylitis", sex: "FEMALE", age: 57 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 44 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 54 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 45 },
  { disease: "Ankylosing Spondylitis", sex: "MALE", age: 53 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 62 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 49 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 52 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 66 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 59 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 65 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 19 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 69 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 67 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 53 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 77 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 56 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 57 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 37 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 69 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 56 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 45 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 53 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 45 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 70 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 76 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 49 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 50 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 63 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 29 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 61 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 44 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 62 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 52 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 51 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 49 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 55 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 55 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 82 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 74 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 36 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 54 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 52 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 35 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 62 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 47 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 52 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 37 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 48 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 73 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 63 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 56 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 45 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 63 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 88 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 50 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 67 },
  { disease: "Rheumatoid Arthritis", sex: "MALE", age: 62 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 59 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 53 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 47 },
  { disease: "Rheumatoid Arthritis", sex: "FEMALE", age: 51 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 75 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 37 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 55 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 58 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 74 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 41 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 67 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 58 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 59 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 61 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 47 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 54 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 67 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 74 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 67 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 75 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 45 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 57 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 60 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 56 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 61 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 57 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 72 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 55 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 59 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 93 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 71 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 66 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 63 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 60 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 52 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 79 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 50 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 64 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 42 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 63 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 60 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 67 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 68 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 73 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 53 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 70 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 66 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 69 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 71 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 60 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 68 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 67 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 78 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 79 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 68 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 72 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 73 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 60 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 70 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 60 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 81 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 69 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 72 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 61 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 39 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 51 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 55 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 58 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 59 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 71 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 59 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 74 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 25 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 54 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 64 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 62 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 42 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 68 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 58 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 56 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 90 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 49 },
  { disease: "Type 2 Diabetes", sex: "FEMALE", age: 33 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 63 },
  { disease: "Type 2 Diabetes", sex: "MALE", age: 57 },
  { disease: "Essential Tremor", sex: "FEMALE", age: 73 },
  { disease: "Idiopathic Granulomatous Mastitis", sex: "FEMALE", age: 31 },
  { disease: "Deep Vein Thrombosis", sex: "FEMALE", age: 30 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 59 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 68 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 75 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 79 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 78 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 61 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 53 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 69 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 76 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 9 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 14 },
  { disease: "Bronchopulmonary Dysplasia", sex: "FEMALE", age: 0 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 6 },
  { disease: "Essential Tremor", sex: "MALE", age: 66 },
  { disease: "Sepsis", sex: "MALE", age: 90 },
  { disease: "Sepsis", sex: "MALE", age: 69 },
  { disease: "Sepsis", sex: "FEMALE", age: 75 },
  { disease: "Sepsis", sex: "FEMALE", age: 75 },
  { disease: "Sepsis", sex: "FEMALE", age: 85 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 11 },
  { disease: "Acute Rheumatic Fever", sex: "MALE", age: 17 },
  { disease: "Gallbladder Stones", sex: "MALE", age: 69 },
  { disease: "Stomach Cancer", sex: "MALE", age: 75 },
  { disease: "Cerebral Venous Thrombosis", sex: "FEMALE", age: 45 },
  { disease: "Cerebral Venous Thrombosis", sex: "MALE", age: 25 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 42 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "MALE", age: 74 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 64 },
  { disease: "Bladder Cancer", sex: "MALE", age: 70 },
  { disease: "Bladder Cancer", sex: "MALE", age: 43 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Gallbladder Stones", sex: "FEMALE", age: 63 },
  { disease: "Stomach Cancer", sex: "MALE", age: 53 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 34 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 24 },
  { disease: "Epilepsy", sex: "FEMALE", age: 26 },
  { disease: "Epilepsy", sex: "FEMALE", age: 31 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 22 },
  { disease: "Multiple Sclerosis", sex: "FEMALE", age: 18 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 15 },
  { disease: "Congenital Heart Diseases", sex: "MALE", age: 3 },
  { disease: "Gluten Enteropathy", sex: "FEMALE", age: 28 },
  { disease: "Periodontitis", sex: "FEMALE", age: 43 },
  { disease: "Anaphylaxis", sex: "FEMALE", age: 19 },
  { disease: "Chronic Hepatitis B", sex: "MALE", age: 52 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 81 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 10 },
  { disease: "Acute Pancreatitis", sex: "FEMALE", age: 51 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 1 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 52 },
  { disease: "Dystonia", sex: "FEMALE", age: 37 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 84 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "MALE", age: 11 },
  { disease: "Lung Cancer", sex: "MALE", age: 72 },
  { disease: "Essential Tremor", sex: "MALE", age: 28 },
  { disease: "Alzheimer's Disease", sex: "FEMALE", age: 58 },
  { disease: "Spontaneous Pneumothorax", sex: "FEMALE", age: 37 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 53 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 70 },
  { disease: "Tuberculosis", sex: "MALE", age: 51 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 45 },
  { disease: "Gynecomastia", sex: "MALE", age: 16 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 47 },
  { disease: "Rotator Cuff Tear", sex: "FEMALE", age: 60 },
  { disease: "Febrile Convulsion", sex: "FEMALE", age: 1 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 56 },
  { disease: "Febrile Convulsion", sex: "FEMALE", age: 1 },
  { disease: "Premature Patent Ductus Arteriosus", sex: "MALE", age: 0 },
  { disease: "Rotator Cuff Tear", sex: "MALE", age: 70 },
  { disease: "Periodontitis", sex: "FEMALE", age: 26 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 58 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 63 },
  { disease: "Frontotemporal Dementia", sex: "FEMALE", age: 74 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 66 },
  { disease: "Diabetic Complications", sex: "FEMALE", age: 78 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 65 },
  { disease: "Brucellosis", sex: "MALE", age: 58 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 67 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 71 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 47 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 82 },
  { disease: "Leukemia", sex: "MALE", age: 60 },
  { disease: "Leukemia", sex: "FEMALE", age: 50 },
  { disease: "Bile Duct Cancer", sex: "FEMALE", age: 87 },
  { disease: "Periodontitis", sex: "MALE", age: 33 },
  { disease: "Bile Duct Cancer", sex: "FEMALE", age: 65 },
  { disease: "Arrhythmias", sex: "MALE", age: 11 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 8 },
  { disease: "Childhood Hypothyroidism", sex: "MALE", age: 3 },
  { disease: "Deep Vein Thrombosis", sex: "MALE", age: 74 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 72 },
  { disease: "Coronary Artery Disease", sex: "MALE", age: 64 },
  { disease: "Coronary Artery Disease", sex: "FEMALE", age: 68 },
  { disease: "Bladder Cancer", sex: "MALE", age: 47 },
  { disease: "Bladder Cancer", sex: "MALE", age: 58 },
  { disease: "Prostate Cancer", sex: "MALE", age: 70 },
  { disease: "Age-Related Macular Degeneration", sex: "FEMALE", age: 70 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 80 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 75 },
  { disease: "Retinal Vein Occlusion", sex: "MALE", age: 76 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 60 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "MALE", age: 63 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "MALE", age: 78 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "FEMALE", age: 48 },
  { disease: "Brucellosis", sex: "FEMALE", age: 62 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "MALE", age: 52 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "FEMALE", age: 72 },
  { disease: "Aortic and Mitral Valve Stenosis and Insufficiency", sex: "FEMALE", age: 64 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 68 },
  { disease: "Congenital Deafness", sex: "MALE", age: 3 },
  { disease: "Congenital Deafness", sex: "FEMALE", age: 2 },
  { disease: "Childhood Hypothyroidism", sex: "MALE", age: 3 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 13 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 13 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 5 },
  { disease: "Cervical Cancer", sex: "FEMALE", age: 44 },
  { disease: "Essential Tremor", sex: "MALE", age: 72 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 11 },
  { disease: "Anaphylaxis", sex: "MALE", age: 39 },
  { disease: "Childhood Hypothyroidism", sex: "MALE", age: 2 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 11 },
  { disease: "Childhood Hypothyroidism", sex: "FEMALE", age: 17 },
  { disease: "Childhood Hypothyroidism", sex: "MALE", age: 1 },
  { disease: "Childhood Hypothyroidism", sex: "MALE", age: 7 },
  { disease: "Esophageal Cancer", sex: "FEMALE", age: 58 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 22 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 31 },
  { disease: "Musculoskeletal System Tumors", sex: "FEMALE", age: 28 },
  { disease: "Musculoskeletal System Tumors", sex: "MALE", age: 14 },
  { disease: "Childhood Isolated Growth Hormone Deficiency", sex: "FEMALE", age: 15 },
  { disease: "Rotator Cuff Tear", sex: "MALE", age: 60 },
  { disease: "Epilepsy", sex: "FEMALE", age: 24 },
  { disease: "Habitual Abortion", sex: "MALE", age: 31 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 22 },
  { disease: "Habitual Abortion", sex: "MALE", age: 28 },
  { disease: "Habitual Abortion", sex: "MALE", age: 36 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 31 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 21 },
  { disease: "Habitual Abortion", sex: "MALE", age: 32 },
  { disease: "Age-Related Macular Degeneration", sex: "MALE", age: 79 },
  { disease: "Retinal Vein Occlusion", sex: "FEMALE", age: 55 },
  { disease: "Habitual Abortion", sex: "FEMALE", age: 44 },
  { disease: "Habitual Abortion", sex: "MALE", age: 46 },
  { disease: "Hydatid Cyst", sex: "MALE", age: 41 },
  { disease: "Epilepsy", sex: "MALE", age: 28 },
  { disease: "Epilepsy", sex: "FEMALE", age: 27 },
  { disease: "Diabetic Complications", sex: "MALE", age: 62 },
  { disease: "Non-Syndromic Congenital Anomaly", sex: "FEMALE", age: 0 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 55 },
  { disease: "Esophageal Cancer", sex: "MALE", age: 41 },
  { disease: "Sepsis", sex: "MALE", age: 79 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 75 },
  { disease: "Chronic Obstructive Pulmonary Disease", sex: "MALE", age: 73 },
  { disease: "Glaucoma", sex: "MALE", age: 42 },
  { disease: "Bronchopulmonary Dysplasia", sex: "FEMALE", age: 0 },
  { disease: "Colon and Rectum Cancer", sex: "FEMALE", age: 45 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 40 },
  { disease: "Parkinson's Disease", sex: "FEMALE", age: 71 },
  { disease: "Lung Cancer", sex: "MALE", age: 69 },
  { disease: "Type 1 Diabetes", sex: "MALE", age: 8 },
  { disease: "Type 1 Diabetes", sex: "FEMALE", age: 9 },
  { disease: "Benign Prostatic Hyperplasia", sex: "MALE", age: 72 },
  { disease: "Essential Tremor", sex: "MALE", age: 75 },
  { disease: "Colon Volvulus", sex: "MALE", age: 39 },
  { disease: "Parkinson's Disease", sex: "MALE", age: 60 },
  { disease: "Colon and Rectum Cancer", sex: "MALE", age: 60 },
  { disease: "Stomach Cancer", sex: "MALE", age: 55 },
  { disease: "Healthy", sex: "MALE", age: 51 },
  { disease: "Healthy", sex: "FEMALE", age: 54 },
  { disease: "Healthy", sex: "MALE", age: 49 },
  { disease: "Healthy", sex: "FEMALE", age: 44 },
  { disease: "Healthy", sex: "MALE", age: 42 },
  { disease: "Healthy", sex: "FEMALE", age: 45 },
  { disease: "Healthy", sex: "MALE", age: 40 },
  { disease: "Healthy", sex: "MALE", age: 41 },
  { disease: "Healthy", sex: "FEMALE", age: 34 },
  { disease: "Healthy", sex: "MALE", age: 37 },
  { disease: "Healthy", sex: "FEMALE", age: 31 },
  { disease: "Healthy", sex: "FEMALE", age: 36 },
  { disease: "Healthy", sex: "MALE", age: 34 },
  { disease: "Healthy", sex: "FEMALE", age: 27 },
  { disease: "Healthy", sex: "FEMALE", age: 26 },
  { disease: "Healthy", sex: "MALE", age: 26 },
  { disease: "Healthy", sex: "MALE", age: 23 },
  { disease: "Healthy", sex: "FEMALE", age: 31 },
  { disease: "Healthy", sex: "FEMALE", age: 36 },
  { disease: "Healthy", sex: "MALE", age: 17 },
  { disease: "Healthy", sex: "MALE", age: 41 },
  { disease: "Healthy", sex: "MALE", age: 10 },
  { disease: "Healthy", sex: "FEMALE", age: 65 },
  { disease: "Healthy", sex: "MALE", age: 65 },
  { disease: "Healthy", sex: "MALE", age: 56 },
  { disease: "Healthy", sex: "FEMALE", age: 53 },
  { disease: "Healthy", sex: "MALE", age: 53 },
  { disease: "Healthy", sex: "FEMALE", age: 46 },
  { disease: "Healthy", sex: "MALE", age: 45 },
  { disease: "Healthy", sex: "MALE", age: 58 },
  { disease: "Healthy", sex: "MALE", age: 55 },
  { disease: "Healthy", sex: "FEMALE", age: 53 },
  { disease: "Healthy", sex: "MALE", age: 50 },
  { disease: "Healthy", sex: "MALE", age: 38 },
  { disease: "Healthy", sex: "FEMALE", age: 47 },
  { disease: "Healthy", sex: "MALE", age: 44 },
  { disease: "Healthy", sex: "MALE", age: 42 },
  { disease: "Healthy", sex: "MALE", age: 50 },
  { disease: "Healthy", sex: "MALE", age: 48 },
  { disease: "Healthy", sex: "MALE", age: 43 },
  { disease: "Healthy", sex: "MALE", age: 33 },
  { disease: "Healthy", sex: "MALE", age: 63 },
  { disease: "Healthy", sex: "MALE", age: 43 },
  { disease: "Healthy", sex: "MALE", age: 56 },
  { disease: "Healthy", sex: "MALE", age: 38 },
  { disease: "Healthy", sex: "FEMALE", age: 44 },
  { disease: "Healthy", sex: "FEMALE", age: 49 },
  { disease: "Healthy", sex: "MALE", age: 37 },
  { disease: "Healthy", sex: "FEMALE", age: 45 },
  { disease: "Healthy", sex: "MALE", age: 51 },
  { disease: "Healthy", sex: "MALE", age: 38 },
  { disease: "Healthy", sex: "FEMALE", age: 49 },
  { disease: "Healthy", sex: "MALE", age: 49 },
  { disease: "Healthy", sex: "FEMALE", age: 47 },
  { disease: "Healthy", sex: "MALE", age: 51 },
  { disease: "Healthy", sex: "FEMALE", age: 56 },
  { disease: "Healthy", sex: "MALE", age: 48 },
  { disease: "Healthy", sex: "MALE", age: 49 },
  { disease: "Healthy", sex: "FEMALE", age: 43 },
  { disease: "Healthy", sex: "FEMALE", age: 45 },
  { disease: "Healthy", sex: "FEMALE", age: 44 },
  { disease: "Healthy", sex: "FEMALE", age: 43 },
  { disease: "Healthy", sex: "FEMALE", age: 42 },
  { disease: "Healthy", sex: "FEMALE", age: 54 },
  { disease: "Healthy", sex: "FEMALE", age: 47 },
  { disease: "Healthy", sex: "MALE", age: 58 },
  { disease: "Healthy", sex: "FEMALE", age: 22 },
  { disease: "Healthy", sex: "MALE", age: 35 },
  { disease: "Healthy", sex: "MALE", age: 46 },
  { disease: "Healthy", sex: "MALE", age: 27 },
  { disease: "Healthy", sex: "MALE", age: 46 },
  { disease: "Healthy", sex: "FEMALE", age: 27 },
  { disease: "Healthy", sex: "FEMALE", age: 41 },
  { disease: "Healthy", sex: "FEMALE", age: 60 },
  { disease: "Healthy", sex: "MALE", age: 56 },
  { disease: "Healthy", sex: "MALE", age: 32 },
  { disease: "Healthy", sex: "FEMALE", age: 42 },
  { disease: "Healthy", sex: "MALE", age: 27 },
  { disease: "Healthy", sex: "MALE", age: 29 },
  { disease: "Healthy", sex: "MALE", age: 48 },
  { disease: "Healthy", sex: "MALE", age: 27 },
  { disease: "Healthy", sex: "MALE", age: 40 },
  { disease: "Healthy", sex: "MALE", age: 36 },
  { disease: "Healthy", sex: "MALE", age: 29 },
  { disease: "Healthy", sex: "MALE", age: 32 },
  { disease: "Healthy", sex: "MALE", age: 61 },
  { disease: "Healthy", sex: "MALE", age: 28 },
  { disease: "Healthy", sex: "MALE", age: 25 },
  { disease: "Healthy", sex: "FEMALE", age: 27 },
  { disease: "Healthy", sex: "FEMALE", age: 26 },
  { disease: "Healthy", sex: "MALE", age: 66 },
  { disease: "Healthy", sex: "MALE", age: 38 },
  { disease: "Healthy", sex: "MALE", age: 36 },
  { disease: "Healthy", sex: "FEMALE", age: 40 },
  { disease: "Healthy", sex: "MALE", age: 30 },
  { disease: "Healthy", sex: "MALE", age: 39 },
  { disease: "Healthy", sex: "FEMALE", age: 25 },
  { disease: "Healthy", sex: "MALE", age: 42 },
  { disease: "Healthy", sex: "MALE", age: 33 },
  { disease: "Healthy", sex: "MALE", age: 32 },
  { disease: "Healthy", sex: "MALE", age: 39 },
  { disease: "Healthy", sex: "MALE", age: 37 },
  { disease: "Healthy", sex: "FEMALE", age: 43 },
  { disease: "Healthy", sex: "MALE", age: 5 },
  { disease: "Healthy", sex: "FEMALE", age: 56 },
  { disease: "Healthy", sex: "MALE", age: 60 },
  { disease: "Healthy", sex: "MALE", age: 9 },
  { disease: "Healthy", sex: "MALE", age: 34 },
  { disease: "Healthy", sex: "FEMALE", age: 31 },
  { disease: "Healthy", sex: "MALE", age: 40 },
  { disease: "Healthy", sex: "FEMALE", age: 72 },
  { disease: "Healthy", sex: "MALE", age: 50 },
  { disease: "Healthy", sex: "MALE", age: 40 },
  { disease: "Healthy", sex: "MALE", age: 33 },
  { disease: "Healthy", sex: "MALE", age: 44 },
  { disease: "Healthy", sex: "FEMALE", age: 39 },
  { disease: "Healthy", sex: "FEMALE", age: 67 },
  { disease: "Healthy", sex: "FEMALE", age: 75 },
  { disease: "Healthy", sex: "MALE", age: 5 },
  { disease: "Healthy", sex: "FEMALE", age: 34 },
  { disease: "Healthy", sex: "FEMALE", age: 54 },
  { disease: "Healthy", sex: "FEMALE", age: 3 },
  { disease: "Healthy", sex: "MALE", age: 45 },
  { disease: "Healthy", sex: "FEMALE", age: 35 },
  { disease: "Healthy", sex: "FEMALE", age: 2 },
  { disease: "Healthy", sex: "MALE", age: 27 },
  { disease: "Healthy", sex: "FEMALE", age: 33 },
  { disease: "Healthy", sex: "MALE", age: 34 },
  { disease: "Healthy", sex: "FEMALE", age: 36 },
  { disease: "Healthy", sex: "MALE", age: 42 },
  { disease: "Healthy", sex: "FEMALE", age: 77 },
  { disease: "Healthy", sex: "FEMALE", age: 72 },
  { disease: "Healthy", sex: "FEMALE", age: 12 },
  { disease: "Healthy", sex: "MALE", age: 3 },
  { disease: "Healthy", sex: "MALE", age: 54 },
  { disease: "Healthy", sex: "FEMALE", age: 47 },
  { disease: "Healthy", sex: "MALE", age: 55 },
  { disease: "Healthy", sex: "MALE", age: 60 },
  { disease: "Healthy", sex: "MALE", age: 33 },
  { disease: "Healthy", sex: "MALE", age: 31 },
  { disease: "Healthy", sex: "FEMALE", age: 68 },
  { disease: "Healthy", sex: "FEMALE", age: 29 },
  { disease: "Healthy", sex: "FEMALE", age: 24 },
  { disease: "Healthy", sex: "FEMALE", age: 21 },
  { disease: "Healthy", sex: "FEMALE", age: 37 },
  { disease: "Healthy", sex: "MALE", age: 20 },
  { disease: "Healthy", sex: "MALE", age: 14 },
  { disease: "Healthy", sex: "FEMALE", age: 46 },
  { disease: "Healthy", sex: "MALE", age: 51 },
  { disease: "Healthy", sex: "MALE", age: 18 },
  { disease: "Healthy", sex: "MALE", age: 1 },
  { disease: "Healthy", sex: "FEMALE", age: 2 },
  { disease: "Healthy", sex: "MALE", age: 43 },
  { disease: "Healthy", sex: "FEMALE", age: 26 },
  { disease: "Healthy", sex: "MALE", age: 32 },
  { disease: "Healthy", sex: "MALE", age: 2 },
  { disease: "Healthy", sex: "MALE", age: 40 },
  { disease: "Healthy", sex: "FEMALE", age: 2 },
  { disease: "Healthy", sex: "MALE", age: 37 },
  { disease: "Healthy", sex: "FEMALE", age: 21 },
  { disease: "Healthy", sex: "MALE", age: 27 },
  { disease: "Healthy", sex: "MALE", age: 49 },
  { disease: "Healthy", sex: "FEMALE", age: 35 },
  { disease: "Healthy", sex: "MALE", age: 40 },
  { disease: "Healthy", sex: "MALE", age: 6 },
  { disease: "Healthy", sex: "MALE", age: 1 },
  { disease: "Healthy", sex: "MALE", age: 35 },
  { disease: "Healthy", sex: "MALE", age: 42 },
  { disease: "Healthy", sex: "MALE", age: 52 },
  { disease: "Healthy", sex: "MALE", age: 38 },
  { disease: "Healthy", sex: "MALE", age: 49 },
  { disease: "Healthy", sex: "MALE", age: 33 },
  { disease: "Healthy", sex: "MALE", age: 55 },
  { disease: "Healthy", sex: "MALE", age: 65 },
  { disease: "Healthy", sex: "MALE", age: 41 },
  { disease: "Healthy", sex: "FEMALE", age: 77 },
  { disease: "Healthy", sex: "MALE", age: 78 },
  { disease: "Healthy", sex: "MALE", age: 1 },
  { disease: "Healthy", sex: "MALE", age: 34 },
  { disease: "Healthy", sex: "FEMALE", age: 54 },
  { disease: "Healthy", sex: "MALE", age: 41 },
  { disease: "Healthy", sex: "FEMALE", age: 41 },
  { disease: "Healthy", sex: "MALE", age: 45 },
  { disease: "Healthy", sex: "MALE", age: 18 },
  { disease: "Healthy", sex: "MALE", age: 46 },
  { disease: "Healthy", sex: "FEMALE", age: 67 },
  { disease: "Healthy", sex: "FEMALE", age: 61 },
  { disease: "Healthy", sex: "FEMALE", age: 62 },
  { disease: "Healthy", sex: "MALE", age: 71 },
  { disease: "Healthy", sex: "MALE", age: 66 },
  { disease: "Healthy", sex: "FEMALE", age: 62 },
  { disease: "Healthy", sex: "MALE", age: 67 },
  { disease: "Healthy", sex: "FEMALE", age: 29 },
  { disease: "Healthy", sex: "FEMALE", age: 27 },
  { disease: "Healthy", sex: "FEMALE", age: 38 },
  { disease: "Healthy", sex: "MALE", age: 28 },
  { disease: "Healthy", sex: "MALE", age: 29 },
  { disease: "Healthy", sex: "FEMALE", age: 37 },
  { disease: "Healthy", sex: "MALE", age: 42 },
  { disease: "Healthy", sex: "FEMALE", age: 29 },
  { disease: "Healthy", sex: "FEMALE", age: 72 },
  { disease: "Healthy", sex: "FEMALE", age: 60 },
  { disease: "Healthy", sex: "MALE", age: 72 },
  { disease: "Healthy", sex: "FEMALE", age: 69 },
  { disease: "Healthy", sex: "MALE", age: 30 },
  { disease: "Healthy", sex: "MALE", age: 63 },
  { disease: "Healthy", sex: "FEMALE", age: 33 },
  { disease: "Healthy", sex: "MALE", age: 32 },
  { disease: "Healthy", sex: "MALE", age: 50 },
  { disease: "Healthy", sex: "MALE", age: 45 },
  { disease: "Healthy", sex: "MALE", age: 8 },
  { disease: "Healthy", sex: "MALE", age: 32 },
  { disease: "Healthy", sex: "FEMALE", age: 25 },
  { disease: "Healthy", sex: "MALE", age: 40 },
  { disease: "Healthy", sex: "MALE", age: 44 },
  { disease: "Healthy", sex: "MALE", age: 42 },
  { disease: "Healthy", sex: "FEMALE", age: 13 },
  { disease: "Healthy", sex: "MALE", age: 55 },
  { disease: "Healthy", sex: "MALE", age: 36 },
  { disease: "Healthy", sex: "MALE", age: 46 },
  { disease: "Healthy", sex: "MALE", age: 48 },
  { disease: "Healthy", sex: "FEMALE", age: 38 },
  { disease: "Healthy", sex: "MALE", age: 48 },
  { disease: "Healthy", sex: "FEMALE", age: 1 },
  { disease: "Healthy", sex: "MALE", age: 21 },
  { disease: "Healthy", sex: "MALE", age: 36 },
  { disease: "Healthy", sex: "MALE", age: 1 },
  { disease: "Healthy", sex: "FEMALE", age: 36 },
  { disease: "Healthy", sex: "MALE", age: 36 },
  { disease: "Healthy", sex: "FEMALE", age: 14 },
  { disease: "Healthy", sex: "MALE", age: 42 },
  { disease: "Healthy", sex: "MALE", age: 6 },
  { disease: "Healthy", sex: "MALE", age: 19 },
  { disease: "Healthy", sex: "FEMALE", age: 42 },
  { disease: "Healthy", sex: "MALE", age: 46 },
  { disease: "Healthy", sex: "FEMALE", age: 14 },
  { disease: "Healthy", sex: "MALE", age: 34 },
];

function WBTAbout() {
  const navigate = useNavigate();
  const [selectedDisease, setSelectedDisease] = useState('');
  const [metadata, setMetadata] = useState([]);
  const [diseases, setDiseases] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [ageData, setAgeData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Trigger animations after component mounts
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 50);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // --- Pure DOM search: no React re-renders until you click a result ---
  const searchRef = useRef(null);
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const searchTimerRef = useRef(null);

  const destroyDropdown = useCallback(() => {
    if (dropdownRef.current) {
      dropdownRef.current.remove();
      dropdownRef.current = null;
    }
  }, []);

  const createDropdownContainer = useCallback(() => {
    destroyDropdown();
    if (!searchRef.current) return null;
    const rect = searchRef.current.getBoundingClientRect();
    const div = document.createElement('div');
    Object.assign(div.style, {
      position: 'fixed', top: `${rect.bottom + 4}px`, left: `${rect.left}px`,
      width: `${rect.width}px`, background: '#fff', borderRadius: '8px',
      border: '1px solid #e2e8f0',
      maxHeight: '350px', overflowY: 'auto', zIndex: '2147483647',
    });
    document.body.appendChild(div);
    dropdownRef.current = div;
    return div;
  }, [destroyDropdown]);

  const showMessage = useCallback((text) => {
    const div = createDropdownContainer();
    if (!div) return;
    const msg = document.createElement('div');
    Object.assign(msg.style, { padding: '12px 16px', color: '#94a3b8', fontSize: '0.9rem' });
    msg.textContent = text;
    div.appendChild(msg);
  }, [createDropdownContainer]);

  const buildDropdown = useCallback((results) => {
    if (!results.length) { showMessage('No results found'); return; }
    const div = createDropdownContainer();
    if (!div) return;

    results.forEach((result, i) => {
      const row = document.createElement('div');
      Object.assign(row.style, {
        padding: '10px 16px', cursor: 'pointer', display: 'flex',
        justifyContent: 'space-between', alignItems: 'center',
        borderBottom: i < results.length - 1 ? '1px solid #f1f5f9' : 'none',
      });
      row.onmouseenter = () => { row.style.background = '#f8fafc'; };
      row.onmouseleave = () => { row.style.background = '#fff'; };
      row.onclick = () => {
        console.log('[WBTAbout Search] clicked result:', result);
        if (searchInputRef.current) searchInputRef.current.value = '';
        destroyDropdown();
        navigate('/wbt/explore', { state: { searchResult: result } });
      };

      const label = document.createElement('span');
      Object.assign(label.style, { fontWeight: '500', color: '#1e293b', fontSize: '0.9rem' });
      label.textContent = result.label;

      const badge = document.createElement('span');
      Object.assign(badge.style, {
        fontSize: '0.75rem', color: '#94a3b8', background: '#f1f5f9',
        padding: '2px 8px', borderRadius: '4px', textTransform: 'capitalize',
        flexShrink: '0', marginLeft: '12px',
      });
      badge.textContent = result.tab;

      row.appendChild(label);
      row.appendChild(badge);
      div.appendChild(row);
    });
  }, [createDropdownContainer, showMessage, destroyDropdown, navigate]);

  const handleSearchChange = useCallback((e) => {
    const query = e.target.value;
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);

    if (!query.trim()) {
      destroyDropdown();
      return;
    }

    showMessage('Searching...');

    searchTimerRef.current = setTimeout(async () => {
      try {
        const res = await fetch(`${SEARCH_API_URL}/search?q=${encodeURIComponent(query.trim())}`);
        if (!res.ok) throw new Error('Search failed');
        const results = await res.json();
        buildDropdown(results);
      } catch (err) {
        console.error('Search error:', err);
        destroyDropdown();
      }
    }, 300);
  }, [buildDropdown, destroyDropdown, showMessage]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        searchRef.current && !searchRef.current.contains(e.target) &&
        (!dropdownRef.current || !dropdownRef.current.contains(e.target))
      ) {
        destroyDropdown();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [destroyDropdown]);

  useEffect(() => {
    return () => destroyDropdown();
  }, [destroyDropdown]);

  useEffect(() => {
    // Use hardcoded metadata instead of fetching TSV file
    setMetadata(METADATA);

        // Get unique diseases
    const uniqueDiseases = [...new Set(METADATA.map(d => d.disease))].sort();
        setDiseases(uniqueDiseases);

        // Set default disease
        if (uniqueDiseases.length > 0) {
          setSelectedDisease(uniqueDiseases[0]);
        }
  }, []);

  useEffect(() => {
    if (selectedDisease && metadata.length > 0) {
      const diseaseData = metadata.filter(d => d.disease === selectedDisease);

      // Gender distribution
      const genderCounts = diseaseData.reduce((acc, d) => {
        acc[d.sex] = (acc[d.sex] || 0) + 1;
        return acc;
      }, {});

      const genderChartData = Object.entries(genderCounts).map(([gender, count]) => ({
        name: gender,
        value: count,
        percentage: ((count / diseaseData.length) * 100).toFixed(1)
      }));

      setGenderData(genderChartData);

      // Age distribution
      const ageGroups = {};
      diseaseData.forEach(d => {
        const ageGroup = Math.floor(d.age / 5) * 5; // Group by 5-year intervals
        ageGroups[ageGroup] = (ageGroups[ageGroup] || 0) + 1;
      });

      const ageChartData = Object.entries(ageGroups)
        .map(([age, count]) => ({
          age: `${age}-${parseInt(age) + 4}`,
          count: count,
          ageNum: parseInt(age)
        }))
        .sort((a, b) => a.ageNum - b.ageNum);

      setAgeData(ageChartData);
    }
  }, [selectedDisease, metadata]);

  // Soft, gentle colors for charts
  const CHART_COLORS = {
    male: '#bfdbfe',         // Soft blue for male
    female: '#fecaca',       // Soft red/pink for female  
    tertiary: '#d1fae5',    // Very soft mint for age chart
    stroke: '#9ca3af'       // Soft gray for lines
  };

const healthConditions = [
  {
    category: "Healthy",
    conditions: "Healthy"
  },
  {
    category: "Autoimmune / Rheumatologic",
    conditions: "Rheumatoid Arthritis, Ankylosing Spondylitis, ANCA-Associated Vasculitis, Atopic Dermatitis, Familial Mediterranean Fever, Systemic Lupus Erythematosus, Scleroderma"
  },
  {
    category: "Cancer / Neoplastic",
    conditions: "Lung Cancer, Stomach Cancer, Breast Cancer, Colon and Rectum Cancer, Cervical Cancer, Liver Cancer, Leukemia, Bladder Cancer, Esophageal Cancer, Lymphoma, Musculoskeletal System Tumors, Bile Duct Cancer, Pancreatic Cancer, Prostate Cancer"
  },
  {
    category: "Cardiovascular",
    conditions: "Congenital Heart Diseases, Coronary Artery Disease, Cerebral Venous Thrombosis, Acute Rheumatic Fever, Deep Vein Thrombosis, Mitral Valve Prolapse, Arrhythmias, Hypertension, Pulmonary Embolism, Premature Patent Ductus Arteriosus, Aortic and Mitral Valve Stenosis and Insufficiency"
  },
  {
    category: "Digestive / Hepatobiliary",
    conditions: "Idiopathic Granulomatous Mastitis, Gallbladder Stones, Gluten Enteropathy, Acute Pancreatitis, Colon Volvulus"
  },
  {
    category: "Renal / Urogenital",
    conditions: "Renal Stones, Benign Prostatic Hyperplasia, Vesicoureteral Reflux, Gynecomastia, Polycystic Kidney Disease, Pyelonephritis"
  },
  {
    category: "Respiratory",
    conditions: "Bronchopulmonary Dysplasia, Chronic Obstructive Pulmonary Disease, Spontaneous Pneumothorax, Asthma"
  },
  {
    category: "Endocrine / Metabolic",
    conditions: "Polycystic Ovary Syndrome, Type 2 Diabetes, Type 1 Diabetes, Diabetic Complications, Childhood Hashimoto's Thyroiditis, Precocious Puberty, Idiopathic Direct Hyperbilirubinemia, Childhood Hypothyroidism"
  },
  {
    category: "Infectious / Inflammatory",
    conditions: "Sepsis, Nonalcoholic Steatohepatitis, Brucellosis, Chronic Hepatitis B, Acute Poststreptococcal Glomerulonephritis, Anaphylaxis, Hydatid Cyst, Tuberculosis"
  },
  {
    category: "Musculoskeletal",
    conditions: "Gonarthrosis, Rotator Cuff Tear, Scoliosis"
  },
  {
    category: "Neurological / Psychiatric",
    conditions: "Bipolar Disorder, Schizophrenia, Epilepsy, Parkinson's Disease, Multiple Sclerosis, Dystonia, Essential Tremor, Alzheimer's Disease, Atypical Parkinsonism, Blepharospasm, Major Depressive Disorder, Febrile Convulsion, Frontotemporal Dementia, First-Episode Psychosis, Neurofibromatosis"
  },
  {
    category: "Pediatric / Congenital / Genetic",
    conditions: "Nocturnal Enuresis, Childhood Renal Stones, Down Syndrome, Non-Syndromic Congenital Anomaly, Congenital Deafness, Childhood Isolated Growth Hormone Deficiency"
  },
  {
    category: "Dental / Oral",
    conditions: "Apical Dental Abscess, Periodontitis"
  },
  {
    category: "Ophthalmologic",
    conditions: "Age-Related Macular Degeneration, Retinal Vein Occlusion, Glaucoma"
  },
  {
    category: "Other / Systemic",
    conditions: "Habitual Abortion, Longevity, Sudden Hearing Loss, Carbon Monoxide Poisoning, Drug Intoxication"
  }
];

  const handleExplore = () => {
    navigate('/wbt/explore');
  };

  // Function to handle disease chip click
  const handleDiseaseChipClick = (disease) => {
    // Clean up the disease name (trim whitespace)
    const cleanDisease = disease.trim();

    // Set the selected disease
    setSelectedDisease(cleanDisease);

    // Scroll to the demographics section with overshoot
    const demographicsCard = document.querySelector('.wbt-about-demographics-card');
    if (demographicsCard) {
      const cardRect = demographicsCard.getBoundingClientRect();
      const cardTop = cardRect.top + window.pageYOffset;

      // Overshoot by scrolling a bit higher than the card
      const overshootOffset = 100; // Scroll 100px above the card
      const targetPosition = cardTop - overshootOffset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Add a brief highlight effect to the dropdown
      setTimeout(() => {
        const diseaseSelector = document.getElementById('disease-select');
        if (diseaseSelector) {
          diseaseSelector.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.3)';
          setTimeout(() => {
            diseaseSelector.style.boxShadow = '';
          }, 2000);
        }
      }, 800); // Delay to let scroll finish
    }
  };

  return (
    <>
      {/* Navigation */}
      <div className="navigation-system">
        <div className="main-nav-container">
          {/* Logo */}
          <a href="/" className="main-logo">
            <img src={logoImage} alt="PhenomeAtlas" className="main-logo-image" />
          </a>

          {/* Platform Menu */}
          <nav className="platform-menu">
            <a href="/wbt" className="platform-link">WBT-Atlas</a>
            {isMobile ? (
              <a href="/contact" className="platform-link">Contact</a>
            ) : (
              <>
                <a href="/contact" className="platform-link">Contact</a>
              </>
            )}
          </nav>

          {/* Search Bar */}
          {!isMobile && (
            <div className="integrated-search" ref={searchRef}>
              <div className="search-input-wrapper">
                <svg className="search-icon" width="18" height="18" viewBox="0 0 20 20" fill="none">
                  <path d="M17.5 17.5L12.5 12.5M14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <input
                  type="text"
                  ref={searchInputRef}
                  placeholder="Search genes, diseases, pathways..."
                  className="integrated-search-input"
                  onChange={handleSearchChange}
                />
                <button className="search-submit-btn-integrated">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6.5 12L11 7.5L6.5 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
          )}

          {/* Mobile Menu Button - only show on mobile */}
          {isMobile && (
            <button className={`mobile-menu-btn ${mobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
              <span></span>
              <span></span>
              <span></span>
            </button>
          )}
        </div>
      </div>

      {/* Mobile Overlay */}
      {isMobile && (
        <>
          <div className={`mobile-overlay ${mobileMenuOpen ? 'open' : ''}`} onClick={closeMobileMenu}></div>
          
          {/* Mobile Sidebar */}
          <div className={`mobile-sidebar ${mobileMenuOpen ? 'open' : ''}`}>
            <div className="mobile-sidebar-content">
              <a href="/wbt" className="mobile-nav-link" onClick={closeMobileMenu}>WBT-Atlas</a>
              <a href="/contact" className="mobile-nav-link" onClick={closeMobileMenu}>Contact</a>
              <a href="https://mphenome.org" className="mobile-nav-link" onClick={closeMobileMenu}>About 1M-PI</a>
          </div>
          </div>
        </>
      )}

    <div className="wbt-about-page">
      {/* Sidebar */}
      <div className={`wbt-about-sidebar ${isLoaded ? 'animate-sidebar' : ''}`}>
        <h1 className="wbt-about-sidebar-title">WBT Atlas</h1>
        
        <div className="wbt-about-sidebar-section">
          <p className="wbt-about-sidebar-label">Dataset Size</p>
          <div className="wbt-about-info-card">
            <div className="wbt-about-info-number">4000+</div>
            <div className="wbt-about-info-text">Blood Samples</div>
          </div>
          </div>

     

        <div className="wbt-about-sidebar-section">
          <p className="wbt-about-sidebar-label">Genes</p>
          <div className="wbt-about-info-card">
            <div className="wbt-about-info-number">20,000+</div>
            <div className="wbt-about-info-text">Genes Analyzed</div>
          </div>
          </div>
        


           <div className="wbt-about-sidebar-section">
          <p className="wbt-about-sidebar-label">Health Conditions</p>
          <div className="wbt-about-info-card">
            <div className="wbt-about-info-number">98</div>
            <div className="wbt-about-info-text">Distinct Conditions</div>
          </div>
          </div>
                <div className="wbt-about-sidebar-section">
          <p className="wbt-about-sidebar-label">Physiological Systems</p>
          <div className="wbt-about-info-card">
            <div className="wbt-about-info-number">15</div>
            <div className="wbt-about-info-text">Disease Categories</div>
          </div>
          </div>

   
          </div>

      {/* Main Content */}
      <div className="wbt-about-main-content">
        <div className="wbt-about-content">
          
          {/* Hero Section */}
          <div className={`wbt-about-hero-card ${isLoaded ? 'animate-hero' : ''}`}>



            <div className="wbt-about-hero-content">

              <div className="wbt-about-hero-text">
                <h1 className="wbt-about-hero-title">Whole Blood Transcriptomics Atlas</h1>
                <p className="wbt-about-hero-description">
The Whole Blood Transcriptomic (WBT) Atlas presents gene expression profiles derived from 4,444 human blood samples spanning 98 distinct health conditions. This resource captures both demographic and disease-associated transcriptomic signatures, offering biological insights into immune perturbations and metabolic dysregulation across a wide range of health conditions. Analyses are enabled at the gene, gene module, and pathway levels across a broad spectrum of diseases.                </p>
     
          </div>
              <div className="wbt-about-explore-btn-container">                            <button 
              onClick={handleExplore}
              className="wbt-about-explore-btn"
            >
              Explore Atlas
            </button></div>

              <div className="wbt-about-hero-image">
                <img src={anatomyImage} alt="Human Anatomy" className="wbt-about-anatomy-image" />
        </div>
                            {/* Health Conditions Grid - Right under description */}
          <div className={`wbt-about-conditions-card ${isLoaded ? 'animate-card-1' : ''}`}>
            <div className="wbt-about-card-title">
              Health Conditions Coverage
              <span className="wbt-about-tag">27 Conditions</span>
      </div>
            <p className="wbt-about-card-subtitle">
              Comprehensive analysis across multiple disease categories and health states
            </p>
            
            
            
   
            <div className="wbt-about-conditions-grid">
              {healthConditions.map((item, index) => (
                <div 
                  key={index} 
                  className={`wbt-about-condition-item ${isLoaded ? 'animate-condition' : ''}`}
                  style={{ animationDelay: `${0.1 + (index * 0.05)}s` }}
                >
                  <h3 className="wbt-about-condition-title">{item.category}</h3>
                  <div className="wbt-about-condition-list">
                    {item.conditions.split(',').map((condition, conditionIndex) => (
                      <span
                        key={conditionIndex}
                        className="wbt-about-disease-chip"
                        onClick={() => handleDiseaseChipClick(condition)}
                        title={`Click to explore ${condition.trim()}`}
                      >
                        {condition.trim()}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
            </div>
          </div>

       

          {/* Interactive Demographics */}
          <div className={`wbt-about-demographics-card ${isLoaded ? 'animate-card-2' : ''}`}>
            <div className="wbt-about-card-title">
              Interactive Demographics
              <span className="wbt-about-tag">Live Data</span>
            </div>
            <p className="wbt-about-card-subtitle">
              Explore demographic distributions across different health conditions
            </p>

            <div className="wbt-about-disease-selector">
              <label htmlFor="disease-select" className="wbt-about-selector-label">
                Select a Health Condition
              </label>
          <select
            id="disease-select"
            value={selectedDisease}
            onChange={(e) => setSelectedDisease(e.target.value)}
                className="wbt-about-disease-select"
          >
            {diseases.map(disease => (
              <option key={disease} value={disease}>{disease}</option>
            ))}
          </select>
        </div>

        {selectedDisease && (
              <div className="wbt-about-charts-container">
                <div className="wbt-about-chart-wrapper">
                  <h3 className="wbt-about-chart-title">Gender Distribution</h3>
                  <div className="wbt-about-chart-content">
                    <ResponsiveContainer width="100%" height={200}>
                <PieChart>
                  <Pie
                    data={genderData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={({ name, percentage }) => `${name}: ${percentage}%`}
                          outerRadius={60}
                          fill={CHART_COLORS.male}
                    dataKey="value"
                          stroke="rgba(255,255,255,0.9)"
                          strokeWidth={1}
                        >
                          {genderData.map((entry, index) => (
                            <Cell 
                              key={`cell-${index}`} 
                              fill={entry.name.toLowerCase().includes('f') ? CHART_COLORS.female : CHART_COLORS.male} 
                            />
                    ))}
                  </Pie>
                        <Tooltip 
                          contentStyle={{
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            border: '1px solid rgba(0, 0, 0, 0.1)',
                            borderRadius: '6px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                            fontSize: '0.75rem'
                          }}
                        />
                </PieChart>
              </ResponsiveContainer>
                  </div>
            </div>

                <div className="wbt-about-chart-wrapper">
                  <h3 className="wbt-about-chart-title">Age Distribution</h3>
                  <div className="wbt-about-chart-content">
                    <ResponsiveContainer width="100%" height={250}>
                      <AreaChart data={ageData} margin={{ top: 5, right: 5, left: -30, bottom: -15 }}>
                        <CartesianGrid strokeDasharray="1 1" stroke="rgba(0,0,0,0.05)" />
                        <XAxis 
                          dataKey="age" 
                          tick={{ fontSize: 10, fill: '#6b7280' }}
                          tickLine={{ stroke: 'rgba(0,0,0,0.1)' }}
                          axisLine={{ stroke: 'rgba(0,0,0,0.1)' }}
                        />
                        <YAxis 
                          tick={{ fontSize: 10, fill: '#6b7280' }}
                          tickLine={{ stroke: 'rgba(0,0,0,0.1)' }}
                          axisLine={{ stroke: 'rgba(0,0,0,0.1)' }}
                        />
                        <Tooltip 
                          contentStyle={{
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            border: '1px solid rgba(0, 0, 0, 0.1)',
                            borderRadius: '6px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                            fontSize: '0.75rem'
                          }}
                        />
                        <Area 
                          type="monotone" 
                          dataKey="count" 
                          stroke={CHART_COLORS.male} 
                          fill={CHART_COLORS.male} 
                          fillOpacity={0.8} 
                          strokeWidth={1}
                        />
                </AreaChart>
              </ResponsiveContainer>
                  </div>
            </div>
          </div>
        )}
      </div>
    </div>
      </div>
    </div>
    </>
  );
}

export default WBTAbout;
